import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Table,
  OverlayTrigger,
  Popover,
  Tooltip as BSTooltip,
  Modal,
  Spinner,
} from "react-bootstrap";
import {
  Link,
  useNavigate,
  useParams,
  useLocation,
  useBlocker,
} from "react-router-dom";
import axios from "axios";
import CancelIcon from "@mui/icons-material/Cancel";
import { IconButton, Tooltip, Box, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { FaSpinner } from "react-icons/fa";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import { IoEyeOutline } from "react-icons/io5";
import { RotatingLines } from "react-loader-spinner";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import { Plus } from "lucide-react";
import FadeLoaderComponent from "../../../components/loader-component";
import ProductAddModel from "./product-add-model";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import AutoSubmitDatePicker from "../../../components/input/date-picker-with-autosubmit";
import { roleTypes } from "../../../data/roleType";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { TextField } from "@mui/material";

const ProductRequestEdit = () => {
  const alertRef = useRef(null);
  const [selectedData, setSelectedData] = useState();
  const [currentData, setCurrentData] = useState();
  const [deleteIsSubmit, setDeleteIsSubmit] = useState(true);
  const [isSubmitItem, setIsSubmitItem] = useState(true);
  const [loader, setLoader] = useState(true);
  const [jobs, setJobs] = useState([]);
  const textareaRef = useRef(null);
  const [successStatus, setSuccessStatus] = useState({});
  const [failStatus, setFailStatus] = useState({});
  const { id } = useParams();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [selectedProductListIds, setSelectedProductListIds] = useState([]);
  const [decodedToken, setDecodedToken] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(null);
  const [searchProducts, setSearchProducts] = useState("");
  const [searchSelectedProducts, setSearchSelectedProducts] = useState("");
  const [jobId, setJobId] = useState(null);
  const [jobIdProductRequest, setJobIdProductRequest] = useState(null);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const [searchProductsList, setSearchProductsList] = useState([]);
  const [searchProductsListTotal, setSearchProductsListTotal] = useState();
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedJobForFilter, setSelectedJobForFilter] = useState(null);
  const [selectedSystemForFilter, setSelectedSystemForFilter] = useState(null);
  const [selectedPhaseForFilter, setSelectedPhaseForFilter] = useState(null);
  const [systemOptions, setSystemOptions] = useState([]);
  const [phaseOptions, setPhaseOptions] = useState([]);
  const [jobSystemsPhases, setJobSystemsPhases] = useState(null);
  const [jobSystemsPhasesMap, setJobSystemsPhasesMap] = useState({});
  const [selectedSystemId, setSelectedSystemId] = useState(null);
  const [selectedPhaseId, setSelectedPhaseId] = useState(null);
  const [systemOptionsModal, setSystemOptionsModal] = useState([]);
  const [phaseOptionsModal, setPhaseOptionsModal] = useState([]);
  const [loadingSystemsPhases, setLoadingSystemsPhases] = useState(false);
  const token = localStorage.getItem("coyote-token");
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });

  const [showOrderConfirmationModal, setShowOrderConfirmationModal] =
    useState(false);
  const [orderModalData, setOrderModalData] = useState({
    poNumber: "",
    warehouseId: null,
    vendorId: null,
    items: [],
  });
  const [showItemsInModal, setShowItemsInModal] = useState(false);

  const permissions = useSelector(SettingSelector.set_permissions);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [modifiedProducts, setModifiedProducts] = useState();
  const [selectedAddedProducts, setSelectedAddedProducts] = useState([]);
  const [originalProductIds, setOriginalProductIds] = useState([]);
  const [validationErrorsPR, setValidationErrorsPR] = useState({});
  const [vendorOptions, setVendorOptions] = useState([]);

  const [activePanel, setActivePanel] = useState("none");
  const showAddProductsPanel = activePanel === "products";
  const isRightPanelOpen = activePanel !== "none";

  const [spSearchText, setSpSearchText] = useState("");
  const [spProducts, setSpProducts] = useState([]);
  const [spTotal, setSpTotal] = useState(0);
  const [spNextOffset, setSpNextOffset] = useState(null);
  const [spLoadingInitial, setSpLoadingInitial] = useState(false);
  const [spLoadingMore, setSpLoadingMore] = useState(false);
  const [spSortConfig, setSpSortConfig] = useState({
    key: "productName",
    direction: "asc",
  });
  const [spSelectedVendorId, setSpSelectedVendorId] = useState("all");
  const [spSelectedProducts, setSpSelectedProducts] = useState([]);
  const [spValidationErrors, setSpValidationErrors] = useState({});
  const [spViewItem, setSpViewItem] = useState(null);
  const [spViewModal, setSpViewModal] = useState(false);
  const [vendors, setVendors] = useState([]);
  const spRequestIdRef = useRef(0);
  const SP_LIMIT = 20;

  const [hoveredTableProduct, setHoveredTableProduct] = useState(null);
  const [draggingRowProduct, setDraggingRowProduct] = useState(null);

  const [bulkJobId, setBulkJobId] = useState(null);
  const [bulkSystemId, setBulkSystemId] = useState(null);
  const [bulkPhaseId, setBulkPhaseId] = useState(null);
  const [bulkSystemOptions, setBulkSystemOptions] = useState([]);
  const [bulkPhaseOptions, setBulkPhaseOptions] = useState([]);

  const optionsVendor = useMemo(() => {
    return [
      { value: "all", label: "Select Vendor" },
      ...vendors.map((v) => ({
        value: v.id,
        label: v.name === "N/A" || !v.name ? "No vendor" : v.name,
      })),
    ];
  }, [vendors]);

  const [leftWidth, setLeftWidth] = useState(55);
  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef(null);

  const startResizing = useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);
  const stopResizing = useCallback(() => setIsResizing(false), []);
  const resize = useCallback(
    (e) => {
      if (isResizing && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const newW = ((e.clientX - rect.left) / rect.width) * 100;
        if (newW >= 32 && newW <= 75) setLeftWidth(newW);
      }
    },
    [isResizing],
  );

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const [panelSelectedKeys, setPanelSelectedKeys] = useState(new Set());
  const [panelMRTData, setPanelMRTData] = useState([]);
  const [panelTotal, setPanelTotal] = useState(0);
  const [panelNextOffset, setPanelNextOffset] = useState(null);
  const [panelLoading, setPanelLoading] = useState(false);
  const [panelLoadingMore, setPanelLoadingMore] = useState(false);
  const [panelSearch, setPanelSearch] = useState("");
  const [panelJobId, setPanelJobId] = useState(null);
  const [panelSystemId, setPanelSystemId] = useState(null);
  const [panelPhaseId, setPanelPhaseId] = useState(null);
  const [panelSystemOptions, setPanelSystemOptions] = useState([]);
  const [panelPhaseOptions, setPanelPhaseOptions] = useState([]);
  const [panelLoadingSystems, setPanelLoadingSystems] = useState(false);
  const [panelSortConfig, setPanelSortConfig] = useState({
    key: "productName",
    direction: "asc",
  });
  const [panelValidationErrors, setPanelValidationErrors] = useState({});
  const panelRequestIdRef = useRef(0);
  const PANEL_LIMIT = 20;

  const validateSelectedProducts = () => {
    const errs = {};
    let hasErrors = false;
    selectedProducts.forEach((item) => {
      const uniqueKey = item.productId;
      errs[uniqueKey] = {};
      if (!item.quantity || item.quantity <= 0) {
        errs[uniqueKey].quantity = "Quantity is required";
        hasErrors = true;
      }
      if (
        item.rate === "" ||
        item.rate === null ||
        item.rate === undefined ||
        parseFloat(item.rate) <= 0
      ) {
        errs[uniqueKey].rate = "Rate must be greater than 0";
        hasErrors = true;
      }
    });
    setValidationErrorsPR(errs);
    return !hasErrors;
  };

  useEffect(() => {
    const actuallyNewProducts = selectedAddedProducts.filter(
      (product) =>
        !product.productItemId &&
        product.itemStatus === "add" &&
        !originalProductIds.includes(product.productId),
    );
    const hasModifications = modifiedProducts?.size > 0;
    setHasUnsavedChanges(actuallyNewProducts.length > 0 || hasModifications);
  }, [selectedAddedProducts, modifiedProducts, originalProductIds]);

  const clearProductModification = (productId) => {
    setModifiedProducts((prev) => {
      const newSet = new Set(prev);
      newSet.delete(productId);
      return newSet;
    });
  };

  const clearAllModifications = () => {
    setModifiedProducts(new Set());
    setSelectedAddedProducts([]);
    setSelectedProducts([]);
  };

  const hasUpdatePermission = permissions?.product_request?.update === true;
  const hasStatusPermission = permissions?.product_request?.status === true;
  const productHasPermission =
    permissions?.product_request?.add_custom_product === true;
  const orderHasCreatePermission = permissions?.purchase_order?.create === true;
  const orderHasViewPermission = permissions?.purchase_order?.view === true;
  const orderHasUpdatePermission = permissions?.purchase_order?.update === true;
  const orderHasDeletePermission = permissions?.purchase_order?.delete === true;
  const orderHasStatusPermission = permissions?.purchase_order?.status === true;
  const warehouseHasCreatePermission = permissions?.warehouse?.create === true;

  const [sortConfig, setSortConfig] = useState({
    key: "productName",
    direction: "asc",
  });
  const [sortConfigProductRequest, setSortConfigProductRequest] = useState({
    key: "productName",
    direction: "asc",
  });

  const [formDataProduct, setFormDataProduct] = useState({
    name: "",
    sku: "",
    categoryId: "",
    manufacturerId: null,
    model: "",
    inventoryType: "standard",
    upcNumber: "",
    msrp: "",
    cost: "",
    labourPerHourPerunit: "",
    rmu: "",
    backbox: "",
    technicalSpecs: [{ key: "", value: "" }],
    description: "",
    unitOfMeasure: "",
    weight: "",
    vendorId: "",
    dimensions: [{ key: "", value: "" }],
    phases: [null],
    productPictures: [],
  });

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname,
  );

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      setShowDiscardModal(true);
      setPendingNavigation(() => blocker.proceed);
    }
  }, [blocker.state]);

  const handleDiscardChanges = useCallback(() => {
    if (blocker.state === "blocked") {
      setHasUnsavedChanges(false);
      clearAllModifications();
      setShowDiscardModal(false);
      if (pendingNavigation) {
        pendingNavigation();
        setPendingNavigation(null);
      } else if (blocker.proceed) blocker.proceed();
    }
  }, [blocker.state, pendingNavigation, blocker]);

  const handleCancelDiscard = useCallback(() => {
    if (blocker.state === "blocked") blocker.reset();
    setShowDiscardModal(false);
    setPendingNavigation(null);
  }, [blocker.state, blocker]);

  const getWarehouses = async (data) => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}user/warehouse-list`,
        config,
      );
      if (response?.data?.response?.data)
        setWarehouses(response?.data?.response?.data);
    } catch (err) {
      setWarehouses([
        {
          id: data?.warehouseId,
          name: data?.warehouseName,
          address: data?.shipTo,
        },
      ]);
    }
  };

  const getVendors = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(`${url.backendURL}vendor/all`, config);
      const allVendors = response.data.response.data || [];
      setVendors(allVendors);
      const options = allVendors.map((vendor) => ({
        value: vendor.id,
        label: vendor.name === "N/A" ? "No vendor" : vendor.name,
      }));
      setVendorOptions(options || []);
    } catch (err) {
      setVendors([]);
      setVendorOptions([]);
    }
  };

  const getProductRequest = async () => {
    const config = { headers: { Authorization: `${token}` } };
    try {
      const response = await axios.get(
        `${url.backendURL}product-request/${id}/detail?type=edit`,
        config,
      );
      const productRequest = response.data.response.data;
      handleShowEdit(productRequest);
      setWarehouseId(productRequest?.warehouseId);
      return productRequest;
    } catch (err) {
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "information");
      setLoader(false);
    }
  };

  const getJobs = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}job/all/${id}`,
        config,
      );
      setJobs(response.data.response.data);
    } catch (err) {
      handleError(err, "product-edit");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!decodedToken) return;
        const data = await getProductRequest();
        await getJobs();
        await getWarehouses(data);
        await getVendors();
        setLoader(false);
      } catch (err) {
        setLoader(false);
      }
    };
    fetchData();
  }, [decodedToken]);

  useEffect(() => {
    function toggleStickyNames() {
      const isWideScreen = window.innerWidth > 650;
      const stickyHeadNames = document.querySelectorAll(".sticky-head-name");
      const stickyDataNames = document.querySelectorAll(".sticky-data-names");
      if (isWideScreen) {
        stickyHeadNames.forEach((head) => {
          head.classList.add("sticky-action-head-buttons");
          const parentRow = head.closest(".tr-user");
          if (parentRow) head.style.height = `${parentRow.offsetHeight}px`;
        });
        stickyDataNames.forEach((data) => {
          data.classList.add("sticky-action-buttons");
          const parentRow = data.closest(".tr-user");
          if (parentRow) data.style.height = `${parentRow.offsetHeight}px`;
        });
      } else {
        stickyHeadNames.forEach((head) => {
          head.classList.remove("sticky-action-head-buttons");
          head.style.height = "auto";
        });
        stickyDataNames.forEach((data) => {
          data.classList.remove("sticky-action-buttons");
          data.style.height = "auto";
        });
      }
    }
    const timeoutId = setTimeout(toggleStickyNames, 100);
    window.addEventListener("resize", toggleStickyNames);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", toggleStickyNames);
    };
  }, [loader, searchProductsList]);

  const [showPopover, setShowPopover] = useState(null);

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current)
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "expired" } },
      );
    } else {
      const responseErrors = response?.data?.error || {};
      setErrors(responseErrors);
      setAlert({
        message: response?.data?.message || "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
      if (
        typeof response?.data?.error === "string" &&
        response?.data?.error?.includes("Invalid operation")
      ) {
        setTimeout(() => navigate("/dashboard/app/product-request-list"), 5100);
      }
    }
  };

  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const orderValidationSchema = Yup.object().shape({
    poNumber: Yup.string()
      .trim()
      .min(3, "PO # must be at least 3 characters")
      .matches(
        /^[A-Za-z0-9-]+$/,
        "PO # can only contain alphanumeric characters and hyphens",
      )
      .required("PO # is required"),
    warehouseId: Yup.number()
      .integer("Warehouse is invalid")
      .positive("Warehouse is invalid")
      .required("Warehouse is required"),
    vendorId: Yup.number()
      .integer("Vendor is invalid")
      .positive("Vendor is invalid")
      .required("Vendor is required"),
    shipToAddress: Yup.string()
      .trim()
      .min(2, "Ship To address must be at least 2 characters")
      .max(255, "Ship To address must not exceed 255 characters")
      .matches(
        /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
        "Ship To address must contain at least one alphanumeric character",
      )
      .required("Ship To address is required"),
    items: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.number().nullable(),
          productItemId: Yup.number().nullable(),
          createOrder: Yup.boolean().nullable(),
        }),
      )
      .test(
        "at-least-one-item",
        "At least one item must be selected for order",
        function (items) {
          if (!items || items.length === 0) return false;
          return items.filter((item) => item.createOrder !== false).length > 0;
        },
      )
      .min(1, "At least one item is required")
      .required("At least one item is required"),
  });

  useEffect(() => {
    const warehouseOpts =
      warehouses.length > 0
        ? warehouses.map((warehouse) => ({
            value: warehouse.id,
            label: warehouse.name,
            shipTo: warehouse.address,
          }))
        : [];
    setWarehouseOptions(warehouseOpts);
  }, [warehouses]);

  const fetchProductRequestDetails = async (productRequestId) => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}product-request/${productRequestId}/detail`,
        config,
      );
      if (response.data.response?.data?.products) {
        return response.data.response.data.products.map((item) => ({
          ...item,
          id: item.productItemId || item.id,
          createOrder: true,
        }));
      }
      return [];
    } catch (error) {
      return [];
    }
  };

  const fetchJobSystemsPhases = async (jobId) => {
    if (!jobId) return null;
    if (jobSystemsPhasesMap[jobId]) return jobSystemsPhasesMap[jobId];
    try {
      setLoadingSystemsPhases(true);
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}product-request/${jobId}/job/systems-with-phases`,
        config,
      );
      const data = response.data.response.data;
      setJobSystemsPhasesMap((prev) => ({ ...prev, [jobId]: data }));
      return data;
    } catch (err) {
      return null;
    } finally {
      setLoadingSystemsPhases(false);
    }
  };

  const handleShowEdit = async (item) => {
    setShowPopover(null);
    if (item) {
      const productRequests = (item?.products || []).map((product) => ({
        ...product,
        itemStatus: "update",
      }));
      const originalIds = productRequests
        .filter((p) => p.productItemId)
        .map((p) => p.productId);
      setOriginalProductIds(originalIds);
      setSelectedData({
        id: item.id || null,
        warehouseId: item.warehouseId || "",
        shipTo: item.shipTo || null,
        status: item?.status,
        date: item.date || "",
        notes: item.notes || "",
        productRequests,
      });
      setCurrentData({
        id: item.id || null,
        warehouseId: item.warehouseId || "",
        shipTo: item.shipTo || null,
        status: item?.status,
        date: item.date || "",
        notes: item.notes || "",
        productRequests,
      });
      setLoader(false);
    }
  };

  const validationSchema = () =>
    Yup.object().shape({
      productRequests: Yup.array()
        .of(
          Yup.object().shape({
            productId: Yup.number()
              .integer()
              .required("Product is required")
              .typeError("Product must be a valid"),
            manufacturerId: Yup.number()
              .integer()
              .required("Manufacturer is required")
              .typeError("Manufacturer must be a valid"),
            jobId: Yup.number()
              .integer()
              .nullable()
              .typeError("Job must be a valid"),
            systemId: Yup.number()
              .integer()
              .nullable()
              .typeError("System must be a valid"),
            phaseId: Yup.number()
              .integer()
              .nullable()
              .typeError("Phase must be a valid"),
            quantity: Yup.number()
              .required("Quantity is required")
              .integer("Quantity must be an integer")
              .typeError("Quantity must be a number")
              .positive("Quantity must be greater than 0"),
            rate: Yup.number()
              .required("Rate is required")
              .typeError("Rate must be a number")
              .moreThan(0, "Rate must be greater than 0")
              .max(9999999999999.99, "Rate cannot exceed 9999999999999.99")
              .transform((value) => (value === "" ? null : value))
              .test(
                "is-decimal",
                "Rate must have a maximum of 2 decimal places",
                (v) =>
                  v === null || /^[+-]?\d+(\.\d{1,2})?$/.test(v.toString()),
              )
              .test(
                "max-digits",
                "Rate cannot have more than 13 digits before decimal point",
                (v) => {
                  if (v === null) return true;
                  const [i] = v.toString().split(".");
                  return i.replace("-", "").length <= 13;
                },
              ),
            amount: Yup.number()
              .required("Amount is required")
              .typeError("Amount must be a number"),
            itemStatus: Yup.string()
              .oneOf(["add"])
              .required("Item status is required"),
          }),
        )
        .min(1, "At least one item is required")
        .required("Items are required"),
    });

  const [optionsJob, setOptionsJob] = useState([]);
  useEffect(() => {
    const jobOptions =
      jobs.length > 0
        ? jobs.map((job) => ({
            value: job.id,
            label: job.name,
            phaseName: job.phaseName,
            systemName: job.systemName,
            siteName: job.siteName,
            status: job.status,
          }))
        : [];
    setOptionsJob(jobOptions);
  }, [jobs]);

  const validationSchemaItem = () =>
    Yup.object().shape({
      productId: Yup.number()
        .integer()
        .required("Product is required")
        .typeError("Product must be a valid"),
      manufacturerId: Yup.number()
        .integer()
        .required("Manufacturer is required")
        .typeError("Manufacturer must be a valid"),
      jobId: Yup.number().integer().nullable().typeError("Job must be a valid"),
      systemId: Yup.number()
        .integer()
        .nullable()
        .typeError("System must be a valid"),
      phaseId: Yup.number()
        .integer()
        .nullable()
        .typeError("Phase must be a valid"),
      quantity: Yup.number()
        .required("Quantity is required")
        .integer("Quantity must be an integer")
        .typeError("Quantity must be a number")
        .positive("Quantity must be greater than 0"),
      rate: Yup.number()
        .required("Rate is required")
        .typeError("Rate must be a number")
        .moreThan(0, "Rate must be greater than 0")
        .max(9999999999999.99, "Rate cannot exceed 9999999999999.99")
        .transform((value) => (value === "" ? null : value))
        .test(
          "is-decimal",
          "Rate must have a maximum of 2 decimal places",
          (v) => v === null || /^[+-]?\d+(\.\d{1,2})?$/.test(v.toString()),
        )
        .test(
          "max-digits",
          "Rate cannot have more than 13 digits before decimal point",
          (v) => {
            if (v === null) return true;
            const [i] = v.toString().split(".");
            return i.replace("-", "").length <= 13;
          },
        ),
      amount: Yup.number()
        .required("Amount is required")
        .typeError("Amount must be a number"),
    });

  const [offset, setOffset] = useState(0);
  const [productCount, setProductCount] = useState(0);
  const [nextOffset, setNextOffset] = useState(0);
  const LIMIT = 20;

  const updateSelectedAddedProducts = useCallback((newProductRequests) => {
    const newProducts = newProductRequests.filter(
      (item) => !item.productItemId && item.itemStatus === "add",
    );
    setSelectedAddedProducts(newProducts);
  }, []);

  const fetchSpProducts = async (
    search = "",
    sortKey = "productName",
    sortDir = "asc",
    lim = SP_LIMIT,
    off = 0,
    existingIds = [],
  ) => {
    try {
      const productIdsString = existingIds.join(",");
      const config = {
        headers: { Authorization: `${token}` },
        params: {
          product: search,
          searchKey: sortKey,
          searchDirection: sortDir,
          limit: lim,
          offset: off,
          selectedProductIds: productIdsString,
          vendorId: spSelectedVendorId === "all" ? null : spSelectedVendorId,
        },
      };
      const response = await axios.get(
        `${url.backendURL}order/products`,
        config,
      );
      const products = response.data.response.data;
      const pagination = response.data.response.pagination;
      return {
        products: products.map((p) => ({
          productId: p.product_id,
          productName: p.product_name,
          rate: p.product_cost,
          quantity: 1,
          amount: 1 * p.product_cost,
          model: p.product_model,
          manufacturerId: p.manufacturer_id,
          manufacturerName: p.manufacturer_name,
          sku: p.sku,
          description: p.product_description,
          jobId: null,
          systemId: null,
          phaseId: null,
          itemStatus: "add",
        })),
        total: pagination.total,
        nextOffset: pagination.nextOffset,
      };
    } catch (error) {
      return { products: [], total: 0, nextOffset: null };
    }
  };

  const spLoadInitial = async (existingIds = []) => {
    setSpLoadingInitial(true);
    spRequestIdRef.current += 1;
    const rid = spRequestIdRef.current;
    try {
      const data = await fetchSpProducts(
        spSearchText,
        spSortConfig.key,
        spSortConfig.direction,
        SP_LIMIT,
        0,
        existingIds,
      );
      if (spRequestIdRef.current !== rid) return;
      setSpProducts(data.products || []);
      setSpTotal(data.total || 0);
      setSpNextOffset(data.nextOffset || null);
    } catch (err) {
      console.error("SP load error:", err);
    } finally {
      if (spRequestIdRef.current === rid) setSpLoadingInitial(false);
    }
  };

  const spLoadMore = async (existingIds = []) => {
    if (!spNextOffset) return;
    setSpLoadingMore(true);
    try {
      const data = await fetchSpProducts(
        spSearchText,
        spSortConfig.key,
        spSortConfig.direction,
        SP_LIMIT,
        spNextOffset,
        existingIds,
      );
      if (data?.products?.length > 0) {
        setSpProducts((prev) => [...prev, ...data.products]);
        setSpTotal(data.total || spTotal);
        setSpNextOffset(data.nextOffset || null);
      }
    } catch (err) {
      console.error("SP load more error:", err);
    } finally {
      setSpLoadingMore(false);
    }
  };

  const resetSpPanel = () => {
    setSpProducts([]);
    setSpSearchText("");
    setSpSelectedProducts([]);
    setSpValidationErrors({});
    setSpSortConfig({ key: "productName", direction: "asc" });
    setSpNextOffset(null);
    setSpTotal(0);
  };

  const excludedIdsKey = useMemo(() => {
    const existingIds =
      selectedData?.productRequests?.map((p) => Number(p.productId)) || [];
    const addedIds =
      selectedAddedProducts.map((p) => Number(p.productId)) || [];
    const allIds = [...new Set([...existingIds, ...addedIds])].filter(
      (id) => !isNaN(id),
    );
    return allIds.sort().join(",");
  }, [selectedData?.productRequests, selectedAddedProducts]);

  useEffect(() => {
    if (activePanel === "products") {
      const allExistingIds = excludedIdsKey
        ? excludedIdsKey.split(",").map(Number)
        : [];
      spLoadInitial(allExistingIds);
    } else {
      resetSpPanel();
    }
  }, [
    activePanel,
    spSearchText,
    spSortConfig.key,
    spSortConfig.direction,
    spSelectedVendorId,
    excludedIdsKey,
  ]);

  const spHandleAdd = (
    setFieldValue,
    currentProductRequests,
    itemsOverride = null,
  ) => {
    const listToAdd = itemsOverride || spSelectedProducts;
    if (listToAdd.length === 0) return;

    const newItems = listToAdd.map((p) => {
      const finalJobId = p.jobId || bulkJobId || null;
      return {
        productId: p.productId,
        productName: p.productName,
        rate: p.rate || 0,
        sku: p.sku || "",
        quantity: p.quantity || 1,
        amount: (p.rate || 0) * (p.quantity || 1),
        model: p.model || "",
        manufacturerId: p.manufacturerId || null,
        manufacturerName: p.manufacturerName || "",
        description: p.description || "",
        jobId: finalJobId,
        systemId:
          p.systemId ||
          (finalJobId && finalJobId == bulkJobId ? bulkSystemId : null) ||
          null,
        phaseId:
          p.phaseId ||
          (finalJobId && finalJobId == bulkJobId ? bulkPhaseId : null) ||
          null,
        itemStatus: "add",
      };
    });

    setSelectedAddedProducts((prev) => [...newItems, ...prev]);
    const existingItems = (currentProductRequests || []).filter(
      (item) => item.productItemId,
    );
    const currentNewItems = (currentProductRequests || []).filter(
      (item) => !item.productItemId,
    );
    setFieldValue("productRequests", [
      ...newItems,
      ...currentNewItems,
      ...existingItems,
    ]);
    setHasUnsavedChanges(true);
    setSpSelectedProducts([]);
    setActivePanel("none");
  };

  const panelCreateKey = (p) => `${p.productId}`;
  const panelIsSelected = (p) => panelSelectedKeys.has(panelCreateKey(p));

  const panelToggleRow = (product) => {
    setPanelSelectedKeys((prev) => {
      const k = panelCreateKey(product);
      const s = new Set(prev);
      s.has(k) ? s.delete(k) : s.add(k);
      return s;
    });
  };

  const panelUpdateField = (productId, key, value) => {
    const update = (item) => {
      if (item.productId !== productId) return item;
      const updated = { ...item, [key]: value };
      if (key === "rate")
        updated.amount =
          (parseFloat(value) || 0) * (parseFloat(item.quantity) || 1);
      if (key === "quantity")
        updated.amount =
          (parseFloat(item.rate) || 0) * (parseFloat(value) || 0);
      return updated;
    };
    setPanelMRTData((prev) => prev.map(update));
  };

  const panelValidate = () => {
    const errs = {};
    let hasErrors = false;
    const selectedItems = panelMRTData.filter((p) => panelIsSelected(p));
    selectedItems.forEach((item) => {
      const k = panelCreateKey(item);
      errs[k] = {};
      if (!item.quantity || item.quantity <= 0) {
        errs[k].quantity = "Quantity is required";
        hasErrors = true;
      }
      if (
        item.rate === "" ||
        item.rate === null ||
        item.rate === undefined ||
        parseFloat(item.rate) <= 0
      ) {
        errs[k].rate = "Rate must be greater than 0";
        hasErrors = true;
      }
    });
    setPanelValidationErrors(errs);
    return !hasErrors;
  };

  const panelHandleAdd = (setFieldValue, currentProductRequests) => {
    if (!panelValidate()) return;
    const selectedItems = panelMRTData.filter((p) => panelIsSelected(p));
    if (selectedItems.length === 0) return;
    const newItems = selectedItems.map((item) => ({
      ...item,
      jobId: item.jobId || panelJobId || null,
      systemId: item.systemId || panelSystemId || null,
      phaseId: item.phaseId || panelPhaseId || null,
      itemStatus: "add",
    }));
    setSelectedAddedProducts((prev) => [...newItems, ...prev]);
    const existingItems = (currentProductRequests || []).filter(
      (item) => item.productItemId,
    );
    const currentNewItems = (currentProductRequests || []).filter(
      (item) => !item.productItemId,
    );
    setFieldValue("productRequests", [
      ...newItems,
      ...currentNewItems,
      ...existingItems,
    ]);
    setPanelSelectedKeys(new Set());
    setPanelValidationErrors({});
    setActivePanel("none");
  };

  const panelResetState = () => {
    setPanelMRTData([]);
    setPanelSearch("");
    setPanelSelectedKeys(new Set());
    setPanelValidationErrors({});
    setPanelJobId(null);
    setPanelSystemId(null);
    setPanelPhaseId(null);
    setPanelSystemOptions([]);
    setPanelPhaseOptions([]);
    setPanelSortConfig({ key: "productName", direction: "asc" });
    setPanelNextOffset(null);
    setPanelTotal(0);
  };

  const getStatusOptions = () => {
    if (
      decodedToken?.roles?.some(
        (role) =>
          role.role_type === roleTypes.ADMIN ||
          role.role_type === roleTypes.PURCHASING ||
          role.role_type === roleTypes.SUPPLIER,
      ) &&
      orderHasCreatePermission &&
      selectedData?.status === "pending" &&
      selectedData?.productRequests?.length > 0
    ) {
      return ["Pending", "Approved", "Rejected", "Create Order"];
    }
    return ["Pending", "Approved", "Rejected"];
  };

  const statusOptionsFormatted = getStatusOptions().map((status) => ({
    value: status.toLowerCase().replace(" ", "_"),
    label: status,
  }));

  const notesSchema = Yup.object().shape({
    notes: Yup.string().required("Please provide notes for this status change"),
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [itemView, setItemView] = useState();
  const [itemViewIndex, setItemViewIndex] = useState();
  const [valuesData, setValuesData] = useState();
  const [itemViewModel, setItemViewModel] = useState(false);
  const [productsViewModel, setProductsViewModel] = useState(false);
  const [productAddModel, setProductAddModel] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [inactiveProductErrors, setInactiveProductErrors] = useState([]);

  const handleView = async (
    e,
    item,
    selectedProductIds = [],
    index,
    valuesData,
  ) => {
    e.preventDefault();
    setShowPopover(null);
    setItemView(item);
    setSelectedProductIds(selectedProductIds);
    setItemViewModel(true);
    setProductAddModel(false);
    setItemViewIndex(index);
    setValuesData(valuesData);
  };

  const handleProductView = async (e, item) => {
    e.preventDefault();
    setItemView(item);
    setItemViewModel(true);
    setProductAddModel(false);
  };

  const handleCloseView = async () => {
    setItemViewModel(false);
    setItemUpdateEnabled(false);
    setProductAddModel(false);
  };

  const handleSubmitProductData = async (
    data,
    setFieldValue,
    addedProducts,
  ) => {
    const productId = data.productId || data.id || data.product_id;
    const finalJobId = jobId || bulkJobId || null;
    data = {
      productId: productId,
      productName: data.productName || data.name,
      rate: data.cost,
      sku: data.sku,
      quantity: 1,
      amount: 1 * data.cost,
      model: data.model,
      manufacturerId: data.manufacturerId,
      manufacturerName: data.manufacturerName,
      description: data.description,
      phases: data.phases,
      phaseNames: data.phase_names || data.phaseNames,
      searchable_text: data.searchable_text,
      jobId: finalJobId,
      systemId:
        (finalJobId && finalJobId == bulkJobId
          ? bulkSystemId
          : selectedSystemId) || null,
      phaseId:
        (finalJobId && finalJobId == bulkJobId
          ? bulkPhaseId
          : selectedPhaseId) || null,
      itemStatus: "add",
    };
    setSelectedAddedProducts((prev) => [data, ...prev]);
    const currentItems = addedProducts || [];
    const existingItems = currentItems.filter((item) => item.productItemId);
    const newItems = currentItems.filter((item) => !item.productItemId);
    setFieldValue("productRequests", [data, ...newItems, ...existingItems]);
  };

  const handleSubmitItem = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    try {
      const config = { headers: { Authorization: `${token}` } };
      const data = {
        productItemId: values?.productItemId || null,
        productId: values.productId,
        jobId: values.jobId,
        systemId: values.systemId || null,
        phaseId: values.phaseId || null,
        manufacturerId: values.manufacturerId,
        quantity: values.quantity,
        rate: values.rate,
        amount: values.amount,
        itemStatus: values?.productItemId ? "update" : "add",
      };
      const response = await axios.put(
        `${url.backendURL}product-request/${id}/item`,
        data,
        config,
      );
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setItemViewIndex(null);
      setItemViewModel(false);
      setItemUpdateEnabled(false);
      const updatedProducts = (valuesData?.productRequests || []).map(
        (product) => {
          if (product.productId === values.productId) {
            return {
              ...product,
              jobId: values.jobId,
              systemId: values.systemId || null,
              phaseId: values.phaseId || null,
              quantity: values.quantity,
              rate: values.rate,
              amount: values.amount,
              itemStatus: "update",
            };
          }
          return product;
        },
      );
      const updatedProductsCurrent = (currentData?.productRequests || []).map(
        (product) => {
          if (product.productId === values.productId) {
            return {
              ...product,
              jobId: values.jobId,
              systemId: values.systemId || null,
              phaseId: values.phaseId || null,
              quantity: values.quantity,
              rate: values.rate,
              amount: values.amount,
              itemStatus: "update",
            };
          }
          return product;
        },
      );
      setCurrentData({
        ...currentData,
        productRequests: updatedProductsCurrent,
      });
      setSelectedData({
        ...selectedData,
        productRequests: updatedProducts || [],
      });
      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "product-edit",
      });
      setValidationErrors({});
      setHasUnsavedChanges(false);
      setErrors({});
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        2000,
      );
    } catch (err) {
      handleError(err, "product-edit");
    } finally {
      setSubmitting(false);
    }
  };

  const [itemUpdateEnabled, setItemUpdateEnabled] = useState(false);

  const handleSaveProductRequestField = async (
    e,
    id,
    field,
    value,
    fieldTwo,
    valueTwo,
  ) => {
    if (e) e.preventDefault();
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "invalid-token" } },
      );
      return;
    }
    try {
      const config = { headers: { Authorization: `${token}` } };
      setErrors(null);
      const fieldData = fieldTwo
        ? { [field]: value, [fieldTwo]: valueTwo }
        : { [field]: value };
      await axios.put(
        `${url.backendURL}product-request/${id}`,
        fieldData,
        config,
      );
      if (fieldTwo)
        setSelectedData({
          ...selectedData,
          [field]: value,
          [fieldTwo]: valueTwo,
        });
      else setSelectedData({ ...selectedData, [field]: value });
      setIsLoading(null);
      setSuccessStatus({ field });
      setTimeout(() => setSuccessStatus({}), 1000);
    } catch (err) {
      setFailStatus({ field });
      setIsLoading(null);
      setTimeout(() => setFailStatus({}), 1000);
      if (alertRef?.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "edit");
    }
  };

  const handleSaveProductRequestFieldSelect = async (
    id,
    field,
    value,
    fieldTwo,
    valueTwo,
  ) => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "invalid-token" } },
      );
      return;
    }
    try {
      const config = { headers: { Authorization: `${token}` } };
      setErrors(null);
      const fieldData = fieldTwo
        ? { [field]: value, [fieldTwo]: valueTwo }
        : { [field]: value };
      const endpoint =
        field === "status"
          ? `${url.backendURL}product-request/${id}/status`
          : `${url.backendURL}product-request/${id}`;
      await axios.put(endpoint, fieldData, config);
      if (fieldTwo)
        setSelectedData({
          ...selectedData,
          [field]: value,
          [fieldTwo]: valueTwo,
        });
      else setSelectedData({ ...selectedData, [field]: value });
      setIsLoading(null);
      setSuccessStatus({ field });
      setTimeout(() => setSuccessStatus({}), 1000);
    } catch (err) {
      setFailStatus({ field });
      setIsLoading(null);
      setTimeout(() => setFailStatus({}), 1000);
      if (alertRef?.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "edit");
    }
  };

  const handleSaveProductItemField = async (
    productItemId,
    fieldOne,
    valueOne,
    fieldTwo,
    valueTwo,
    fieldThree,
    valueThree,
    fieldFour,
    valueFour,
    fieldFive,
    valueFive,
  ) => {
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "invalid-token" } },
      );
      return;
    }
    try {
      const config = { headers: { Authorization: `${token}` } };
      setErrors(null);
      let requestData = { productItemId, [fieldOne]: valueOne };
      if (fieldTwo) requestData[fieldTwo] = valueTwo;
      if (fieldThree) requestData[fieldThree] = valueThree;
      if (fieldFour) requestData[fieldFour] = valueFour;
      if (fieldFive) requestData[fieldFive] = valueFive;
      await axios.put(
        `${url.backendURL}product-request/${selectedData?.id}/item`,
        requestData,
        config,
      );
      clearProductModification(productItemId);
      setIsLoading(false);
      if (fieldTwo) setSuccessStatus({ field: fieldTwo });
      setTimeout(() => setSuccessStatus({}), 2000);
      setIsLoadingJob(false);
      setIsLoadingQuantity(false);
      setIsLoadingRate(false);
      setValidationErrors({});
      return true;
    } catch (err) {
      setIsLoading(false);
      setIsLoadingJob(false);
      setIsLoadingQuantity(false);
      setIsLoadingRate(false);
      if (fieldTwo) setFailStatus({ field: fieldTwo });
      setTimeout(() => setFailStatus({}), 2000);
      if (err.response?.data?.message === "Invalid format") {
        const errorsObj = {};
        const errorData = err.response.data.error;
        Object.entries(errorData).forEach(([field, messages]) => {
          if (!errorsObj[productItemId]) errorsObj[productItemId] = {};
          errorsObj[productItemId][field] = messages[0];
        });
        setValidationErrors(errorsObj);
      } else if (alertRef?.current) {
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      handleError(err, "edit");
      return false;
    } finally {
      setTimeout(() => setIsLoadingIndex(null), 2000);
    }
  };

  const [isSaveSuccessful, setIsSaveSuccessful] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const handleSaveNewProductItemField = async (e, values) => {
    e.preventDefault();
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "invalid-token" } },
      );
      return;
    }
    const data = values.map((item) => ({
      itemStatus: "add",
      productId: item.productId,
      manufacturerId: item.manufacturerId,
      jobId: item.jobId,
      systemId: item.systemId || null,
      phaseId: item.phaseId || null,
      quantity: item.quantity,
      rate: item.rate,
      amount: item.amount,
    }));
    try {
      const schema = validationSchema();
      await schema.validate({ productRequests: data }, { abortEarly: false });
      setErrors(null);
      const config = { headers: { Authorization: `${token}` } };
      const dataNew = values
        .filter((item) => !item.productItemId)
        .map((item) => ({
          itemStatus: item.itemStatus,
          productId: item.productId,
          jobId: item.jobId,
          systemId: item.systemId || null,
          phaseId: item.phaseId || null,
          quantity: item.quantity,
          rate: item.rate,
          amount: item.amount,
        }));
      setErrors(null);
      setValidationErrors(null);
      const response = await axios.put(
        `${url.backendURL}product-request/${selectedData?.id}/items`,
        { items: dataNew },
        config,
      );
      clearAllModifications();
      setInactiveProductErrors([]);
      setAlert({
        message: response && response.data.message,
        type: "success",
        show: true,
        alertFor: "edit",
      });
      if (alertRef?.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setIsSaveSuccessful(true);
      setIsLoading(false);
      setIsLoadingJob(false);
      setIsLoadingQuantity(false);
      setIsLoadingRate(false);
      getProductRequest();
      setValidationErrors({});
      setTimeout(() => {
        setIsSaveSuccessful(false);
        setAlert({ show: false, alertFor: "", message: "", type: "" });
      }, 5000);
      return true;
    } catch (err) {
      if (err.name === "ValidationError") {
        const errorsObj = {};
        err.inner.forEach((validationError) => {
          const { path, message } = validationError;
          const match = path.match(/^productRequests\[(\d+)\]\.(.+)$/);
          if (match) {
            const index = parseInt(match[1]);
            const field = match[2];
            const productId = data[index]?.productId;
            if (productId) {
              if (!errorsObj[productId]) errorsObj[productId] = {};
              errorsObj[productId][field] = message;
            }
          }
        });
        setValidationErrors(errorsObj);
      } else {
        if (err.response?.data?.response?.data) {
          setInactiveProductErrors(
            err.response.data.response.data.map((error) => error.productId),
          );
        }
        if (alertRef?.current)
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        handleError(err, "edit");
      }
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingIndex, setIsLoadingIndex] = useState(null);
  const [isLoadingJob, setIsLoadingJob] = useState(false);
  const [isLoadingQuantity, setIsLoadingQuantity] = useState(false);
  const [isLoadingRate, setIsLoadingRate] = useState(false);
  const [showPopoverItem, setShowPopoverItem] = useState(null);

  useEffect(() => {
    const fetchSystemsPhasesForProducts = async () => {
      if (selectedData?.productRequests && jobs.length > 0) {
        const uniqueJobIds = [
          ...new Set(
            selectedData.productRequests.map((p) => p.jobId).filter((j) => j),
          ),
        ];
        if (uniqueJobIds.length > 0)
          await fetchBulkJobSystemsPhases(uniqueJobIds);
      }
    };
    fetchSystemsPhasesForProducts();
  }, [selectedData?.productRequests, jobs]);

  const fetchBulkJobSystemsPhases = async (jobIds) => {
    if (!jobIds || jobIds.length === 0) return {};
    const uncachedJobIds = jobIds.filter(
      (jobId) => !jobSystemsPhasesMap[jobId],
    );
    if (uncachedJobIds.length === 0) return jobSystemsPhasesMap;
    try {
      setLoadingSystemsPhases(true);
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.post(
        `${url.backendURL}warehouse/jobs/active/system-phases`,
        { jobIds: uncachedJobIds },
        config,
      );
      const apiData = response.data.response.data;
      const bulkData = {};
      apiData.forEach((job) => {
        const systemsMap = {};
        job.systems_phases.forEach((sp) => {
          if (!systemsMap[sp.system_id]) {
            systemsMap[sp.system_id] = {
              system_id: sp.system_id,
              system_name: sp.system_name,
              is_active_system: sp.system_id === job.active_system_id,
              phases: [],
            };
          }
          systemsMap[sp.system_id].phases.push({
            phase_id: sp.phase_id,
            phase_name: sp.phase_name,
            is_active: sp.phase_id === job.active_phase_id,
          });
        });
        bulkData[job.job_id] = {
          active_system_id: job.active_system_id,
          active_phase_id: job.active_phase_id,
          systems: Object.values(systemsMap),
        };
      });
      setJobSystemsPhasesMap((prev) => ({ ...prev, ...bulkData }));
      return bulkData;
    } catch (err) {
      return {};
    } finally {
      setLoadingSystemsPhases(false);
    }
  };

  const togglePopoverItem = (idx) => {
    setShowPopoverItem((prev) => (prev === idx ? null : idx));
  };

  useEffect(() => {
    const handleScroll = () => {
      if (showPopoverItem !== null) setShowPopoverItem(null);
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [showPopoverItem]);

  const handleDeleteProductItem = async (e, id, productItemId) => {
    e.preventDefault();
    if (!token) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "invalid-token" } },
      );
      return;
    }
    try {
      const config = { headers: { Authorization: `${token}` } };
      setErrors(null);
      const response = await axios.delete(
        `${url.backendURL}product-request/${id}/item/${productItemId}`,
        config,
      );
      if (alertRef?.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setAlert({
        message: response && response.data.message,
        type: "success",
        show: true,
        alertFor: "edit",
      });
      setShowPopover(null);
      const updatedItems = selectedData?.productRequests.filter(
        (item) => item.productItemId !== productItemId,
      );
      setSelectedData({ ...selectedData, productRequests: updatedItems });
      setDeleteIsSubmit(true);
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
      return true;
    } catch (err) {
      if (alertRef?.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      handleError(err, "edit");
      setDeleteIsSubmit(true);
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    const cursorPosition = textareaRef.current
      ? textareaRef.current.selectionStart
      : 0;
    setSelectedData({ ...selectedData, shipTo: value });
    if (textareaRef.current) {
      setTimeout(
        () =>
          textareaRef.current.setSelectionRange(cursorPosition, cursorPosition),
        0,
      );
    }
  };

  const [loadingStates, setLoadingStates] = useState({});

  const handleClick = async (e, item, index) => {
    e.preventDefault();
    setLoadingStates((prev) => ({ ...prev, [index]: true }));
    try {
      await handleSaveNewProductItemField(e, item);
    } catch (err) {
      console.error("Error saving item:", err);
    } finally {
      setLoadingStates((prev) => ({ ...prev, [index]: false }));
      setIsSubmitItem(true);
    }
  };

  const handleClickItems = async (e, item) => {
    e.preventDefault();
    let isSubmitted = false;
    try {
      isSubmitted = await handleSaveNewProductItemField(e, item);
    } catch (err) {
      if (err.response?.data?.response?.data) {
        setInactiveProductErrors(
          err.response.data.response.data.map((error) => error.productId),
        );
      }
    } finally {
      setIsSubmitItem(true);
      return isSubmitted;
    }
  };

  const handleSubmitStatusNotes = async (option) => {
    setIsLoading("status");
    if (option.value === "create_order") {
      try {
        const prItems = await fetchProductRequestDetails(selectedData?.id);
        const prWarehouseId = selectedData?.warehouseId || warehouseId;
        const prWarehouse = warehouseOptions.find(
          (w) => w.value === prWarehouseId,
        );
        const defaultShipTo = selectedData?.shipTo || prWarehouse?.shipTo || "";
        setOrderModalData({
          poNumber: "",
          warehouseId: prWarehouseId,
          shipToAddress: defaultShipTo,
          items:
            prItems.length > 0
              ? prItems
              : (selectedData?.productRequests || []).map((item) => ({
                  ...item,
                  id: item.productItemId || item.id,
                  createOrder: true,
                })),
        });
        setShowOrderConfirmationModal(true);
        setIsLoading(false);
        return;
      } catch (error) {
        setIsLoading(false);
        setAlert({
          message: "Failed to load product request details",
          type: "danger",
          show: true,
          alertFor: "edit",
        });
        return;
      }
    }
    handleSaveProductRequestFieldSelect(
      selectedData?.id,
      "status",
      option.value,
    )
      .then(() => {
        setSuccessStatus({ field: "status" });
        if (option.value === "approved") {
          if (alertRef.current)
            alertRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          setAlert({
            message: "Request status updated to approved successfully",
            type: "success",
            show: true,
            alertFor: "orders",
          });
          setTimeout(() => {
            setAlert({ show: false, alertFor: "", message: "", type: "" });
            navigate("/dashboard/app/product-request-list");
          }, 5000);
        }
        setShowModal(false);
        setIsLoading(false);
      })
      .catch(() => {
        setFailStatus({ field: "status" });
        setIsLoading(false);
      });
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedStatus(null);
  };

  const handleSubmitNotes = (values, formikProps) => {
    setIsLoading("status");
    handleSaveProductRequestFieldSelect(
      selectedData?.id,
      "status",
      selectedStatus?.value,
      "notes",
      values.notes,
    )
      .then(() => {
        setSuccessStatus({ field: "status" });
        formikProps.setFieldValue("status", selectedStatus?.value || null);
        setShowModal(false);
        setIsLoading(false);
        setHasUnsavedChanges(false);
        navigate("/dashboard/app/product-request-list");
      })
      .catch(() => {
        setFailStatus({ field: "status" });
        setIsLoading(false);
      });
  };

  const [isCollapsed, setIsCollapsed] = useState(!hasStatusPermission);
  useEffect(() => setIsCollapsed(!hasStatusPermission), [hasStatusPermission]);
  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  const handleSortProductRequest = async (columnKey, setFieldValue, values) => {
    let direction = "asc";
    if (
      sortConfigProductRequest.key === columnKey &&
      sortConfigProductRequest.direction === "asc"
    )
      direction = "desc";
    else if (
      sortConfigProductRequest.key === columnKey &&
      sortConfigProductRequest.direction === "desc"
    )
      direction = "asc";
    setSortConfigProductRequest({ key: columnKey, direction });
    setFieldValue(
      "productRequests",
      [...values.productRequests].sort((a, b) => {
        let aValue = a[columnKey]?.toString().toLowerCase();
        let bValue = b[columnKey]?.toString().toLowerCase();
        if (aValue < bValue) return direction === "asc" ? -1 : 1;
        if (aValue > bValue) return direction === "asc" ? 1 : -1;
        return 0;
      }),
    );
  };

  const [isLoadingMoreSelectedProduct, setIsLoadingMoreSelectedProduct] =
    useState(false);
  const [loadingJobSystemPhase, setLoadingJobSystemPhase] = useState({});
  const [focusedField, setFocusedField] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [clickSubmitProduct, setClickSubmitProduct] = useState(false);

  useEffect(
    () => setCurrentPage(1),
    [searchSelectedProducts, jobIdProductRequest],
  );

  const generateSearchableText = (item, job, actualSystemName, actualPhaseName) => {
    return [
      item.productName,
      item.manufacturerName,
      item.model,
      item.description,
      item.sku,
      job?.name,
      job?.siteName,
      actualPhaseName,
      actualSystemName,
      item.searchable_text,
      item.phaseNames || item.phase_names,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/[+-]/g, "");
  };

  const getFilteredItems = (items) => {
    if (
      !searchSelectedProducts.trim() &&
      !jobIdProductRequest &&
      !selectedSystemForFilter &&
      !selectedPhaseForFilter
    )
      return items || [];
    const normalize = (str) => str?.toLowerCase().replace(/[+-]/g, "") || "";
    const searchTerm = normalize(searchSelectedProducts);
    return (items || []).filter((item) => {
      const job = jobs.find((job) => job.id === item.jobId) || {};
      let actualSystemName = job.systemName;
      let actualPhaseName = job.phaseName;

      if (item.jobId && jobSystemsPhasesMap[item.jobId]) {
        const sys = jobSystemsPhasesMap[item.jobId].systems?.find(
          (s) => String(s.system_id) === String(item.systemId)
        );
        if (sys) {
          actualSystemName = sys.system_name;
          const phase = sys.phases?.find(
            (p) => String(p.phase_id) === String(item.phaseId)
          );
          if (phase) actualPhaseName = phase.phase_name;
        }
      }

      let searchMatch = true;
      if (searchSelectedProducts.trim()) {
        const combinedText = generateSearchableText(item, job, actualSystemName, actualPhaseName);
        const tokens = searchTerm.trim().split(/\s+/);
        searchMatch = tokens.every((token) => combinedText.includes(token));
      }
      const jobMatch = jobIdProductRequest
        ? item.jobId?.toString() === jobIdProductRequest?.toString()
        : true;
      const systemMatch = selectedSystemForFilter
        ? item.systemId === selectedSystemForFilter.value
        : true;
      const phaseMatch = selectedPhaseForFilter
        ? item.phaseId === selectedPhaseForFilter.value
        : true;
      return searchMatch && jobMatch && systemMatch && phaseMatch;
    });
  };

  const getPaginatedItems = (items) => {
    const filteredItems = getFilteredItems(items);
    return filteredItems.slice(0, currentPage * itemsPerPage);
  };
  const hasMoreItems = (items) => {
    const filteredItems = getFilteredItems(items);
    return filteredItems.length > currentPage * itemsPerPage;
  };
  const loadMoreItems = async () => {
    setIsLoadingMoreSelectedProduct(true);
    setCurrentPage((prev) => prev + 1);
    setIsLoadingMoreSelectedProduct(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (showPopover !== null) setShowPopover(null);
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [showPopover]);

  const handleCreateOrderFromPR = async (passedData = null) => {
    try {
      setIsLoading(true);
      const targetData = passedData || orderModalData;
      const selectedOrderItems = targetData.items.filter(
        (item) => item.createOrder !== false,
      );
      if (selectedOrderItems.length === 0) {
        setAlert({
          message: "At least one item is required to create an order",
          type: "danger",
          show: true,
          alertFor: "order-modal",
        });
        setTimeout(
          () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
          5000,
        );
        setIsLoading(false);
        return;
      }
      if (!targetData.warehouseId) {
        setAlert({
          message: "Warehouse is required",
          type: "danger",
          show: true,
          alertFor: "order-modal",
        });
        setTimeout(
          () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
          5000,
        );
        setIsLoading(false);
        return;
      }
      if (!targetData.vendorId) {
        setAlert({
          message: "Vendor is required",
          type: "danger",
          show: true,
          alertFor: "order-modal",
        });
        setTimeout(
          () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
          5000,
        );
        setIsLoading(false);
        return;
      }
      const itemIds = selectedOrderItems
        .map((item) => item.id || item.productItemId)
        .filter((id) => id !== undefined && id !== null);
      if (itemIds.length === 0) {
        setAlert({
          message: "Items are missing. Please refresh and try again",
          type: "danger",
          show: true,
          alertFor: "order-modal",
        });
        setTimeout(
          () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
          5000,
        );
        setIsLoading(false);
        return;
      }
      const config = { headers: { Authorization: `${token}` } };
      const orderResponse = await axios.put(
        `${url.backendURL}product-request/${selectedData?.id}/status/create-order`,
        {
          poNumber: targetData.poNumber.toString().trim(),
          orderWarehouseId: targetData.warehouseId,
          vendorId: targetData.vendorId,
          orderShipTo: targetData.shipToAddress.toString().trim(),
          itemIds,
        },
        config,
      );
      setSelectedData((prev) =>
        prev ? { ...prev, status: "approved" } : prev,
      );
      setAlert({ show: false, alertFor: "", message: "", type: "" });
      setShowOrderConfirmationModal(false);
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      const successMessage =
        orderResponse.data.message || "Order created successfully";
      setOrderModalData({
        poNumber: "",
        warehouseId: null,
        vendorId: null,
        shipToAddress: "",
        items: [],
      });
      const orderId = orderResponse.data.response?.data?.orderId;
      const canAccessPurchaseOrders =
        orderHasViewPermission ||
        orderHasCreatePermission ||
        orderHasUpdatePermission ||
        orderHasDeletePermission ||
        orderHasStatusPermission;
      if (canAccessPurchaseOrders) {
        setTimeout(
          () =>
            navigate("/dashboard/app/purchase-order-list", {
              state: {
                highlightedOrderId: orderId,
                showSuccessMessage: true,
                successMessage,
              },
            }),
          1500,
        );
      } else {
        setAlert({
          message: successMessage,
          type: "success",
          show: true,
          alertFor: "edit",
        });
        setTimeout(
          () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
          3000,
        );
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data?.error?.message ||
        err.message ||
        "An error occurred while creating the order";
      setAlert({
        message: errorMessage,
        type: "danger",
        show: true,
        alertFor: "order-modal",
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .table-user .sticky-action-buttons { background-color: #ffffff !important; z-index: 2; }
        .table-user .bg-selected-product .sticky-action-buttons { background-color: #f5f6fa !important; }
        .table-user .tr-user:hover .sticky-action-buttons { background-color: #f5f6fa !important; }
        .table-user .sticky-action-head-buttons { background: #e2e4e9 !important; }
        .table-user .sticky-action-head-buttons, .table-user .sticky-action-buttons {
          left: 0; z-index: 11; position: absolute; width: 260px; height: inherit;
          display: flex; align-items: center; padding-left: 15px;
          border-bottom: 1px solid #ebedef !important;
        }
        .table-user .sticky-action-buttons { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .table-user .th-user:nth-child(2), .table .td-user:nth-child(2) { padding-left: 275px !important; }
        @media (max-width: 650px) {
          .table-user .sticky-action-head-buttons, .table-user .sticky-action-buttons { position: static !important; width: auto !important; white-space: normal !important; }
          .table-user .th-user:nth-child(2), .table .td-user:nth-child(2) { padding-left: 0.75rem !important; }
        }
        .compact-pagination-toolbar .MuiToolbar-root { min-height: 48px !important; }
        .compact-pagination-topbar .MuiToolbar-root { min-height: 48px !important; }
      `}</style>

      <div>
        <div className="bd-example">
          <div className="d-flex justify-content-between flex-wrap pl-0">
            {/* ── Discard Modal ── */}
            <Modal
              show={showDiscardModal}
              onHide={handleCancelDiscard}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
                <Modal.Title>Unsaved Changes</Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  style={{ position: "absolute", right: "1rem" }}
                  onClick={handleCancelDiscard}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>
              <Modal.Body className="text-center px-4 pt-2">
                <p
                  className="text-muted mb-4 px-2"
                  style={{ fontSize: "1rem", lineHeight: "1.5" }}
                >
                  You have unsaved products added. Do you want to discard these
                  changes?
                </p>
              </Modal.Body>
              <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
                <Button
                  type="button"
                  className="btn btn-white me-4"
                  variant="btn btn-white"
                  onClick={handleDiscardChanges}
                  style={{
                    borderRadius: "25px",
                    fontWeight: "500",
                    minWidth: "100px",
                    borderColor: "#6c757d",
                    color: "#6c757d",
                  }}
                >
                  Discard
                </Button>
                <Button
                  className="px-4 py-2"
                  style={{
                    backgroundColor: "#3a57e8",
                    borderColor: "#3a57e8",
                    borderRadius: "25px",
                    fontWeight: "500",
                    minWidth: "100px",
                  }}
                  onClick={handleCancelDiscard}
                >
                  Continue
                </Button>
              </Modal.Footer>
            </Modal>

            {/* ── Status Notes Modal ── */}
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header className="custom-modal-header">
                <Modal.Title className="h6">
                  Change Status to {selectedStatus?.label}
                </Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  onClick={handleClose}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>
              <Formik
                initialValues={{ notes: selectedData?.notes || "" }}
                validationSchema={notesSchema}
                onSubmit={(values, formikProps) =>
                  handleSubmitNotes(values, formikProps)
                }
              >
                {({ values, handleSubmit, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Notes <span className="text-danger">*</span>
                        </Form.Label>
                        <Field
                          as="textarea"
                          name="notes"
                          value={values.notes}
                          className={`form-control ${errors.notes && touched.notes ? "is-invalid" : ""}`}
                          placeholder="Please provide notes for this status change"
                          rows={4}
                        />
                        <ErrorMessage
                          name="notes"
                          component="div"
                          className="invalid-feedback"
                        />
                      </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="primary"
                        type="submit"
                        disabled={isLoading === "status"}
                      >
                        {isLoading === "status" ? "Saving..." : "Save Changes"}
                      </Button>
                      <Button variant="danger" onClick={handleClose}>
                        Cancel
                      </Button>
                    </Modal.Footer>
                  </Form>
                )}
              </Formik>
            </Modal>

            {/* ── View Item Modal ── */}
            <Modal
              show={itemViewModel}
              onHide={handleCloseView}
              backdrop="true"
              keyboard={true}
              size="lg"
            >
              <Modal.Header className="custom-modal-header">
                <Modal.Title>
                  {itemUpdateEnabled ? "Update" : "View"} Item
                </Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  onClick={handleCloseView}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>
              <Formik
                initialValues={itemView}
                validationSchema={validationSchemaItem}
                onSubmit={handleSubmitItem}
                enableReinitialize
              >
                {({
                  values,
                  handleChange,
                  handleBlur,
                  setFieldValue,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form
                    className="form-horizontal ps-3 pe-3"
                    onSubmit={handleSubmit}
                  >
                    <FocusError />
                    <Modal.Body>
                      {alert.alertFor === "item-edit" && (
                        <AlertNotificationSimple
                          type={alert.type}
                          message={alert.message}
                          show={alert.show}
                          onClose={() => setAlert({ ...alert, show: false })}
                        />
                      )}
                      <Row>
                        <Col sm="6">
                          <Form.Group className="form-group">
                            <Form.Label>
                              Product Name{" "}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              readOnly
                              type="text"
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              value={values?.productName || ""}
                              style={{
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                            <ErrorMessage
                              name="productId"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm="6">
                          <Form.Group className="form-group">
                            <Form.Label>
                              Make <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              readOnly
                              type="text"
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              value={values?.manufacturerName || ""}
                              style={{
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                            <Form.Control
                              type="hidden"
                              name="manufacturerId"
                              value={values?.manufacturerId || ""}
                            />
                            <ErrorMessage
                              name="manufacturerId"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6">
                          <Form.Group className="form-group">
                            <Form.Label>
                              Model <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              readOnly
                              type="text"
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              value={values?.model || ""}
                              style={{
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>Site Name</Form.Label>
                            <Form.Control
                              readOnly
                              type="text"
                              value={
                                values.jobId
                                  ? optionsJob.find(
                                      (o) => o.value === values.jobId,
                                    )?.siteName || "N/A"
                                  : "N/A"
                              }
                              style={{
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={12}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Description <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              readOnly
                              as="textarea"
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              value={values?.description}
                              onChange={handleChange}
                              name="description"
                              style={{
                                resize: "none",
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="6">
                          <Form.Group className="form-group">
                            <Form.Label>
                              Quantity <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="quantity"
                              step="1"
                              min={0}
                              value={values?.quantity || ""}
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "") {
                                  setFieldValue("quantity", "");
                                  setFieldValue("amount", "");
                                  return;
                                }
                                const parsedValue = parseInt(value, 10);
                                if (
                                  !isNaN(parsedValue) &&
                                  parsedValue.toString() === value
                                ) {
                                  setFieldValue("quantity", parsedValue);
                                  setFieldValue(
                                    "amount",
                                    (parsedValue * (values.rate || 0)).toFixed(
                                      2,
                                    ),
                                  );
                                }
                              }}
                              style={{ fontSize: "0.8rem" }}
                            />
                            <ErrorMessage
                              name="quantity"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Rate <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              step="0.01"
                              name="rate"
                              min={0}
                              value={values?.rate || ""}
                              disabled={
                                !itemUpdateEnabled ||
                                values.itemStatus === "add" ||
                                selectedData?.status === "rejected"
                              }
                              onChange={(e) => {
                                let value = e.target.value;
                                if (
                                  /^\d*\.?\d{0,2}$/.test(value) ||
                                  value === ""
                                ) {
                                  setFieldValue("rate", value);
                                  setFieldValue(
                                    "amount",
                                    value
                                      ? (
                                          parseFloat(value) *
                                          (values.quantity || 0)
                                        ).toFixed(2)
                                      : "0.00",
                                  );
                                }
                              }}
                              style={{ fontSize: "0.8rem" }}
                            />
                            <ErrorMessage
                              name="rate"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Amount <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              readOnly
                              name="amount"
                              value={values?.amount || 0}
                              style={{
                                fontSize: "0.8rem",
                                cursor: "not-allowed",
                              }}
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Job <span className="text-danger">*</span>
                            </Form.Label>
                            {itemUpdateEnabled &&
                            values.itemStatus === "update" &&
                            hasUpdatePermission ? (
                              <Select
                                name="jobId"
                                options={optionsJob}
                                value={optionsJob.find(
                                  (o) => o.value === values.jobId,
                                )}
                                onChange={async (selectedOption) => {
                                  const newJobId =
                                    selectedOption?.value || null;
                                  setFieldValue("jobId", newJobId);
                                  setFieldValue("systemId", null);
                                  setFieldValue("phaseId", null);
                                  if (newJobId) {
                                    const jobData =
                                      await fetchJobSystemsPhases(newJobId);
                                    if (
                                      jobData?.active_system_id &&
                                      jobData?.active_phase_id
                                    ) {
                                      setFieldValue(
                                        "systemId",
                                        jobData.active_system_id,
                                      );
                                      setFieldValue(
                                        "phaseId",
                                        jobData.active_phase_id,
                                      );
                                    }
                                  }
                                }}
                                isClearable
                                placeholder="Select Job"
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                styles={{
                                  container: (b) => ({ ...b, width: "100%" }),
                                  control: (b) => ({
                                    ...b,
                                    fontSize: "0.8rem",
                                  }),
                                  option: (b, s) => ({
                                    ...b,
                                    backgroundColor: s.isSelected
                                      ? "#007bff"
                                      : s.isFocused
                                        ? "#e6f7ff"
                                        : "#fff",
                                    color: "#333",
                                    fontSize: "0.8rem",
                                  }),
                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                }}
                              />
                            ) : (
                              <Form.Control
                                readOnly
                                type="text"
                                value={
                                  values?.jobId
                                    ? optionsJob.find(
                                        (o) => o.value === values.jobId,
                                      )?.label || "No Job Assigned"
                                    : "No Job Assigned"
                                }
                                style={{
                                  fontSize: "0.8rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            )}
                            <ErrorMessage
                              name="jobId"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              System <span className="text-danger">*</span>
                            </Form.Label>
                            {itemUpdateEnabled &&
                            values.itemStatus === "update" &&
                            hasUpdatePermission ? (
                              <Select
                                name="systemId"
                                options={
                                  values.jobId &&
                                  jobSystemsPhasesMap[values.jobId]
                                    ? jobSystemsPhasesMap[
                                        values.jobId
                                      ].systems.map((s) => ({
                                        value: s.system_id,
                                        label: s.system_name,
                                      }))
                                    : []
                                }
                                value={
                                  values.jobId &&
                                  jobSystemsPhasesMap[values.jobId] &&
                                  values.systemId
                                    ? jobSystemsPhasesMap[values.jobId].systems
                                        .map((s) => ({
                                          value: s.system_id,
                                          label: s.system_name,
                                        }))
                                        .find(
                                          (o) => o.value === values.systemId,
                                        )
                                    : null
                                }
                                onChange={async (selectedOption) => {
                                  const newSystemId =
                                    selectedOption?.value || null;
                                  setFieldValue("systemId", newSystemId);
                                  setFieldValue("phaseId", null);
                                  if (newSystemId && values.jobId) {
                                    const jobData =
                                      jobSystemsPhasesMap[values.jobId];
                                    if (
                                      newSystemId ===
                                        jobData?.active_system_id &&
                                      jobData?.active_phase_id
                                    ) {
                                      const activeSystem = jobData.systems.find(
                                        (s) => s.system_id === newSystemId,
                                      );
                                      if (
                                        activeSystem?.phases.some(
                                          (p) =>
                                            p.phase_id ===
                                            jobData.active_phase_id,
                                        )
                                      ) {
                                        setFieldValue(
                                          "phaseId",
                                          jobData.active_phase_id,
                                        );
                                      }
                                    }
                                  }
                                }}
                                isClearable
                                isDisabled={!values.jobId}
                                placeholder={
                                  values.jobId
                                    ? "Select system"
                                    : "First select a job"
                                }
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                styles={{
                                  container: (b) => ({ ...b, width: "100%" }),
                                  control: (b) => ({
                                    ...b,
                                    fontSize: "0.8rem",
                                  }),
                                  option: (b, s) => ({
                                    ...b,
                                    backgroundColor: s.isSelected
                                      ? "#007bff"
                                      : s.isFocused
                                        ? "#e6f7ff"
                                        : "#fff",
                                    color: "#333",
                                    fontSize: "0.8rem",
                                  }),
                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                }}
                              />
                            ) : (
                              <Form.Control
                                readOnly
                                type="text"
                                value={
                                  values.jobId &&
                                  values.systemId &&
                                  jobSystemsPhasesMap[values.jobId]
                                    ? jobSystemsPhasesMap[
                                        values.jobId
                                      ].systems.find(
                                        (s) => s.system_id === values.systemId,
                                      )?.system_name || "N/A"
                                    : "N/A"
                                }
                                style={{
                                  fontSize: "0.8rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            )}
                            <ErrorMessage
                              name="systemId"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                        <Col sm={6}>
                          <Form.Group className="form-group">
                            <Form.Label>
                              Phase <span className="text-danger">*</span>
                            </Form.Label>
                            {itemUpdateEnabled &&
                            values.itemStatus === "update" &&
                            hasUpdatePermission ? (
                              <Select
                                name="phaseId"
                                options={
                                  values.jobId &&
                                  values.systemId &&
                                  jobSystemsPhasesMap[values.jobId]
                                    ? jobSystemsPhasesMap[values.jobId].systems
                                        .find(
                                          (s) =>
                                            s.system_id === values.systemId,
                                        )
                                        ?.phases.map((p) => ({
                                          value: p.phase_id,
                                          label: p.phase_name,
                                        })) || []
                                    : []
                                }
                                value={
                                  values.jobId &&
                                  values.systemId &&
                                  jobSystemsPhasesMap[values.jobId] &&
                                  values.phaseId
                                    ? jobSystemsPhasesMap[values.jobId].systems
                                        .find(
                                          (s) =>
                                            s.system_id === values.systemId,
                                        )
                                        ?.phases.map((p) => ({
                                          value: p.phase_id,
                                          label: p.phase_name,
                                        }))
                                        .find((o) => o.value === values.phaseId)
                                    : null
                                }
                                onChange={(selectedOption) =>
                                  setFieldValue(
                                    "phaseId",
                                    selectedOption?.value || null,
                                  )
                                }
                                isClearable
                                isDisabled={!values.systemId}
                                placeholder={
                                  values.systemId
                                    ? "Select phase"
                                    : "First select a system"
                                }
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuPlacement="auto"
                                styles={{
                                  container: (b) => ({ ...b, width: "100%" }),
                                  control: (b) => ({
                                    ...b,
                                    fontSize: "0.8rem",
                                  }),
                                  option: (b, s) => ({
                                    ...b,
                                    backgroundColor: s.isSelected
                                      ? "#007bff"
                                      : s.isFocused
                                        ? "#e6f7ff"
                                        : "#fff",
                                    color: "#333",
                                    fontSize: "0.8rem",
                                  }),
                                  menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                }}
                              />
                            ) : (
                              <Form.Control
                                readOnly
                                type="text"
                                value={
                                  values.jobId &&
                                  values.systemId &&
                                  values.phaseId &&
                                  jobSystemsPhasesMap[values.jobId]
                                    ? jobSystemsPhasesMap[values.jobId].systems
                                        .find(
                                          (s) =>
                                            s.system_id === values.systemId,
                                        )
                                        ?.phases.find(
                                          (p) => p.phase_id === values.phaseId,
                                        )?.phase_name || "N/A"
                                    : "N/A"
                                }
                                style={{
                                  fontSize: "0.8rem",
                                  cursor: "not-allowed",
                                }}
                              />
                            )}
                            <ErrorMessage
                              name="phaseId"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      {itemUpdateEnabled ? (
                        <div className="d-flex justify-content-end mt-4">
                          <Button
                            variant="light"
                            className="me-2"
                            onClick={handleCloseView}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            variant="btn btn-primary"
                            className="me-2"
                            disabled={
                              isSubmitting ||
                              selectedData?.status === "rejected"
                            }
                          >
                            Update
                          </Button>
                        </div>
                      ) : (
                        values.itemStatus === "update" &&
                        hasUpdatePermission && (
                          <div className="d-flex justify-content-end mt-4">
                            <Button
                              type="button"
                              variant="btn btn-primary"
                              className="me-2"
                              onClick={(e) => {
                                e.preventDefault();
                                setItemUpdateEnabled(true);
                              }}
                            >
                              Edit
                            </Button>
                          </div>
                        )
                      )}
                    </Modal.Body>
                  </Form>
                )}
              </Formik>
            </Modal>

            {/* ── SP View Product Modal ── */}
            <Modal
              show={spViewModal}
              onHide={() => {
                setSpViewModal(false);
                setSpViewItem(null);
              }}
              backdrop="true"
              keyboard={true}
              size="lg"
              style={{ zIndex: 99999 }}
            >
              <Modal.Header className="custom-modal-header">
                <Modal.Title>View Product</Modal.Title>
                <button
                  type="button"
                  className="btn-close-svg"
                  onClick={() => {
                    setSpViewModal(false);
                    setSpViewItem(null);
                  }}
                  aria-label="Close"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </Modal.Header>
              <Modal.Body>
                {spViewItem && (
                  <>
                    <Row>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.description || ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Make</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.manufacturerName || ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Model</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.model || ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>SKU</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.sku || ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="12">
                        <Form.Group className="form-group">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            readOnly
                            as="textarea"
                            value={spViewItem.description || ""}
                            style={{
                              resize: "none",
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Quantity</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.quantity ?? ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Rate</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.rate ?? ""}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <Form.Group className="form-group">
                          <Form.Label>Amount</Form.Label>
                          <Form.Control
                            readOnly
                            type="text"
                            value={spViewItem.amount ?? 0}
                            style={{
                              fontSize: "0.8rem",
                              cursor: "not-allowed",
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </Modal.Body>
            </Modal>
          </div>
        </div>

        <Row>
          <Col xl="12" lg="12" ref={alertRef}>
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div
                  className="breadcrumb header-title"
                  style={{ cursor: "pointer" }}
                >
                  <h4
                    onClick={() =>
                      navigate("/dashboard/app/product-request-list")
                    }
                    className="text-primary card-title"
                    style={{ cursor: "pointer" }}
                  >
                    <span>Product Request</span>
                  </h4>
                  <h4 className="mx-2 card-title">{">"}</h4>
                  <h4 className="card-title">Edit</h4>
                </div>
                <div>
                  <div
                    onClick={toggleCollapse}
                    className="sidebar-toggle"
                    style={{
                      position: "initial",
                      marginRight: "1.5rem",
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className="icon"
                      style={{
                        transform: isCollapsed
                          ? "rotate(270deg)"
                          : "rotate(90deg)",
                      }}
                    >
                      <svg
                        width="20"
                        className="icon-20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.25 12.2744L19.25 12.2744"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </i>
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                {/* ── Top Info Form (date / status / warehouse) ── */}
                <Formik
                  enableReinitialize
                  initialValues={{ ...selectedData }}
                  validationSchema={validationSchema}
                >
                  {({
                    values,
                    handleChange,
                    handleBlur,
                    touched,
                    setFieldValue,
                    handleSubmit,
                    isSubmitting,
                    resetForm,
                  }) => {
                    return (
                      <Form>
                        <FocusError />
                        <AlertNotificationSimple
                          type={alert.type}
                          message={alert.message}
                          show={alert.show}
                          onClose={() => setAlert({ ...alert, show: false })}
                        />
                        {selectedData && !isCollapsed && !loader && (
                          <Form className="form-horizontal">
                            <Row className="mb-4 new-product-request-info d-flex align-items-end">
                              <Col md={3}>
                                <AutoSubmitDatePicker
                                  name="date"
                                  label="Date"
                                  value={selectedData?.date}
                                  selectedData={selectedData}
                                  hasUpdatePermission={hasUpdatePermission}
                                  errors={errors}
                                  handleSaveProductRequestField={
                                    handleSaveProductRequestField
                                  }
                                  isLoading={isLoading}
                                  setIsLoading={setIsLoading}
                                  successStatus={successStatus}
                                  failStatus={failStatus}
                                  setFailStatus={setFailStatus}
                                />
                              </Col>
                              <Col
                                md={3}
                                className="d-flex flex-column justify-content-end mb-2"
                              >
                                <div>
                                  <Form.Label htmlFor="status">
                                    Update Status{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "inline-block",
                                      width: "100%",
                                    }}
                                  >
                                    <Select
                                      closeMenuOnScroll={(e) => {
                                        try {
                                          const target = e.target;
                                          if (
                                            !target ||
                                            !target.nodeType ||
                                            typeof target.closest !== "function"
                                          )
                                            return true;
                                          const isMenuScroll =
                                            target.closest(
                                              '[class*="MenuList"]',
                                            ) ||
                                            target.closest('[class*="menu"]');
                                          return !isMenuScroll;
                                        } catch (error) {
                                          return true;
                                        }
                                      }}
                                      name="status"
                                      isDisabled={
                                        !hasStatusPermission ||
                                        isLoading === "status"
                                      }
                                      isLoading={isLoading === "status"}
                                      options={statusOptionsFormatted}
                                      value={statusOptionsFormatted?.find(
                                        (o) => o.value === selectedData?.status,
                                      )}
                                      onChange={(e) => {
                                        setSelectedStatus(e);
                                        if (e?.value === selectedData?.status) {
                                          setFieldValue("status", e.value);
                                          return;
                                        } else if (e?.value === "rejected")
                                          setShowModal(true);
                                        else if (
                                          e?.value === "pending" ||
                                          e?.value === "approved"
                                        ) {
                                          handleSubmitStatusNotes(e);
                                          setFieldValue("status", e.value);
                                        } else if (
                                          e?.value === "create_order"
                                        ) {
                                          getWarehouses();
                                          getVendors();
                                          handleSubmitStatusNotes(e);
                                        }
                                      }}
                                      isClearable
                                      placeholder="Select Status"
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      menuPlacement="auto"
                                      styles={{
                                        control: (b) => ({
                                          ...b,
                                          color: "#5e667b",
                                          backgroundColor:
                                            !hasStatusPermission && "white",
                                          borderColor:
                                            successStatus?.field === "status"
                                              ? "green"
                                              : failStatus?.field ===
                                                  "status" && "red",
                                          boxShadow:
                                            successStatus?.field === "status"
                                              ? "0 0 5px green"
                                              : failStatus.field === "status" &&
                                                "0 0 5px red",
                                        }),
                                        option: (b, s) => ({
                                          ...b,
                                          backgroundColor: s.isSelected
                                            ? "#007bff"
                                            : s.isFocused
                                              ? "#e6f7ff"
                                              : "#fff",
                                          color: "#333",
                                        }),
                                        menuPortal: (b) => ({
                                          ...b,
                                          zIndex: 9999,
                                        }),
                                      }}
                                    />
                                    {isLoading === "status" && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "40%",
                                          right: "50%",
                                          transform: "translateY(-50%)",
                                          pointerEvents: "none",
                                        }}
                                      >
                                        <RotatingLines
                                          strokeWidth="5"
                                          animationDuration="0.75"
                                          width="20"
                                          color="#b2b4b9"
                                          strokeColor="#b2b4b9"
                                          visible={true}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  {errors?.status?.map((error, index) => (
                                    <span
                                      key={index}
                                      className="w-100 mt-1 small text-danger"
                                    >
                                      {error}
                                      <br />
                                    </span>
                                  ))}
                                </div>
                              </Col>
                              <Col md={6}>
                                <Row className="flex justify-content-end">
                                  <Col sm={12} lg={8}>
                                    <Form.Group className="col-md-12 form-group flex flex-end">
                                      <Form.Label
                                        htmlFor="shipTo"
                                        className="d-flex"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        Requesting Warehouse
                                        <span
                                          className="d-flex flex-row"
                                          style={{
                                            width: "100%",
                                            display: "contents",
                                          }}
                                        >
                                          <span className="text-danger">*</span>
                                          <div
                                            style={{
                                              position: "relative",
                                              display: "contents",
                                            }}
                                          >
                                            <Select
                                              closeMenuOnScroll={(e) => {
                                                try {
                                                  const target = e.target;
                                                  if (
                                                    !target ||
                                                    !target.nodeType ||
                                                    typeof target.closest !==
                                                      "function"
                                                  )
                                                    return true;
                                                  const isMenuScroll =
                                                    target.closest(
                                                      '[class*="MenuList"]',
                                                    ) ||
                                                    target.closest(
                                                      '[class*="menu"]',
                                                    );
                                                  return !isMenuScroll;
                                                } catch (error) {
                                                  return true;
                                                }
                                              }}
                                              name="warehouseId"
                                              options={warehouseOptions}
                                              value={warehouseOptions.find(
                                                (option) =>
                                                  option.value === warehouseId,
                                              )}
                                              isDisabled={!hasUpdatePermission}
                                              onChange={(option) => {
                                                if (option?.value) {
                                                  setIsLoading("warehouseId");
                                                  setWarehouseId(
                                                    option?.value || null,
                                                  );
                                                  const shipTo =
                                                    warehouseOptions.find(
                                                      (warehouse) =>
                                                        warehouse.value ===
                                                        option?.value,
                                                    )?.shipTo;
                                                  setFieldValue(
                                                    "warehouseId",
                                                    option?.value || null,
                                                  );
                                                  setFieldValue(
                                                    "shipTo",
                                                    shipTo || values.shipTo,
                                                  );
                                                  handleSaveProductRequestFieldSelect(
                                                    selectedData.id,
                                                    "warehouseId",
                                                    option?.value,
                                                    "shipTo",
                                                    shipTo || values?.shipTo,
                                                  );
                                                }
                                              }}
                                              isClearable
                                              noOptionsMessage={() => (
                                                <div
                                                  style={{
                                                    textAlign: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  <span
                                                    style={{ color: "#666" }}
                                                  >
                                                    No warehouse found.
                                                    {(warehouseHasCreatePermission ||
                                                      decodedToken?.roles.some(
                                                        (role) =>
                                                          role.role_type ===
                                                          roleTypes.SUPER_ADMIN,
                                                      )) && (
                                                      <span>
                                                        {" "}
                                                        <Link
                                                          to="/dashboard/app/warehouse-add"
                                                          style={{
                                                            color: "#007bff",
                                                            textDecoration:
                                                              "none",
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          Add new
                                                        </Link>
                                                      </span>
                                                    )}
                                                  </span>
                                                </div>
                                              )}
                                              placeholder={
                                                warehouseOptions.length ===
                                                0 ? (
                                                  <span>
                                                    No warehouse found
                                                  </span>
                                                ) : (
                                                  "Select Warehouse..."
                                                )
                                              }
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              className="display-content-dropdown"
                                              styles={{
                                                container: (provided) => ({
                                                  ...provided,
                                                  backgroundColor:
                                                    !hasUpdatePermission &&
                                                    "white",
                                                }),
                                                option: (provided, state) => ({
                                                  ...provided,
                                                  backgroundColor:
                                                    state.isSelected
                                                      ? "#007bff"
                                                      : state.isFocused
                                                        ? "#e6f7ff"
                                                        : !hasUpdatePermission
                                                          ? "white"
                                                          : "#fff",
                                                  color: "#333",
                                                }),
                                                control: (provided) => ({
                                                  ...provided,
                                                  marginLeft: "1rem",
                                                  width: "100%",
                                                  color: "#5e667b",
                                                  backgroundColor:
                                                    !hasUpdatePermission &&
                                                    "white",
                                                  borderColor:
                                                    successStatus.field ===
                                                    "warehouseId"
                                                      ? "green"
                                                      : failStatus.field ===
                                                          "warehouseId" &&
                                                        "red",
                                                  boxShadow:
                                                    successStatus.field ===
                                                    "warehouseId"
                                                      ? "0 0 5px green"
                                                      : failStatus.field ===
                                                          "warehouseId" &&
                                                        "0 0 5px red",
                                                }),
                                                menuPortal: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                }),
                                                menu: (provided) => ({
                                                  ...provided,
                                                  zIndex: 9999,
                                                }),
                                              }}
                                            />
                                            {isLoading === "warehouseId" && (
                                              <div
                                                style={{
                                                  position: "absolute",
                                                  top: "13.5%",
                                                  right: "4.5%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                }}
                                              >
                                                <RotatingLines
                                                  strokeWidth="5"
                                                  animationDuration="0.75"
                                                  width="20"
                                                  strokeColor="#b2b4b9"
                                                  color="#b2b4b9"
                                                  visible={true}
                                                />
                                              </div>
                                            )}
                                            {errors?.warehouseId?.map(
                                              (error, index) => (
                                                <span
                                                  key={index}
                                                  className="w-100 mt-1 small text-danger"
                                                >
                                                  {error}
                                                  <br />
                                                </span>
                                              ),
                                            )}
                                          </div>
                                        </span>
                                      </Form.Label>
                                      <div
                                        style={{
                                          position: "relative",
                                          display: "contents",
                                          width: "100%",
                                        }}
                                      >
                                        <Form.Control
                                          className="col-md-12 mb-0"
                                          as="textarea"
                                          type="text"
                                          name="shipTo"
                                          placeholder="Enter Shipment Address"
                                          value={values.shipTo}
                                          onChange={handleInputChange}
                                          disabled={!hasUpdatePermission}
                                          style={{
                                            resize: "none",
                                            height: "150px",
                                            border: "1px solid #dee2e6",
                                            borderRadius: "4px",
                                            padding: "4px 8px",
                                            width: "100%",
                                            backgroundColor:
                                              !hasUpdatePermission && "white",
                                            borderColor:
                                              successStatus.field === "shipTo"
                                                ? "green"
                                                : failStatus.field ===
                                                    "shipTo" && "red",
                                            boxShadow:
                                              successStatus.field === "shipTo"
                                                ? "0 0 5px green"
                                                : failStatus.field ===
                                                    "shipTo" && "0 0 5px red",
                                          }}
                                          onBlur={(e) => {
                                            setIsLoading("shipTo");
                                            if (
                                              selectedData?.shipTo?.length >= 2
                                            )
                                              handleSaveProductRequestField(
                                                e,
                                                selectedData.id,
                                                "shipTo",
                                                selectedData?.shipTo,
                                              );
                                            else {
                                              setFailStatus({
                                                field: "shipTo",
                                                id: selectedData?.id,
                                              });
                                              setTimeout(() => {
                                                setFailStatus({});
                                                setIsLoading(null);
                                              }, 1000);
                                            }
                                          }}
                                          ref={textareaRef}
                                        />
                                        {isLoading === "shipTo" && (
                                          <div
                                            style={{
                                              position: "absolute",
                                              top: "16%",
                                              right: "4.5%",
                                              transform: "translateY(-50%)",
                                              pointerEvents: "none",
                                            }}
                                          >
                                            <RotatingLines
                                              strokeWidth="5"
                                              animationDuration="0.75"
                                              color="#b2b4b9"
                                              width="20"
                                              strokeColor="#b2b4b9"
                                              visible={true}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {errors?.shipTo?.map((error, index) => (
                                        <span
                                          key={index}
                                          className="w-100 mt-1 small text-danger"
                                        >
                                          {error}
                                          <br />
                                        </span>
                                      ))}
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        )}
                      </Form>
                    );
                  }}
                </Formik>

                {/* ── Items Formik ── */}
                {selectedData && !loader && (
                  <Formik
                    initialValues={{
                      productRequests: selectedData?.productRequests || [],
                      id: selectedData?.id,
                    }}
                    enableReinitialize
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      touched,
                      setFieldValue,
                      setFieldTouched,
                      handleSubmit,
                      isSubmitting,
                      validateField,
                      errors: errorsFormik,
                    }) => {
                      const spTableColumns = useMemo(
                        () => [
                          {
                            id: "spSelect",
                            size: 50,
                            Header: () => {
                              const allSel =
                                spProducts.length > 0 &&
                                spProducts.every((p) =>
                                  spSelectedProducts.some(
                                    (sp) => sp.productId === p.productId,
                                  ),
                                );
                              return (
                                <Checkbox
                                  checked={allSel && !spLoadingInitial}
                                  disabled={spLoadingInitial}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      const newOnes = spProducts.filter(
                                        (p) =>
                                          !spSelectedProducts.some(
                                            (sp) =>
                                              sp.productId === p.productId,
                                          ),
                                      );
                                      setSpSelectedProducts((prev) => [
                                        ...prev,
                                        ...newOnes.map((p) => ({
                                          ...p,
                                          quantity: p.quantity || 1,
                                          rate: p.rate || 0,
                                          amount:
                                            (p.rate || 0) * (p.quantity || 1),
                                        })),
                                      ]);
                                    } else {
                                      const keys = spProducts.map(
                                        (p) => p.productId,
                                      );
                                      setSpSelectedProducts((prev) =>
                                        prev.filter(
                                          (p) => !keys.includes(p.productId),
                                        ),
                                      );
                                    }
                                  }}
                                />
                              );
                            },
                            Cell: ({ row }) => {
                              const p = row.original;
                              if (p.isLoadMoreRow) {
                                return (
                                  <div
                                    style={{
                                      position: "sticky",
                                      left: 0,
                                      right: 0,
                                      width: "fit-content",
                                      margin: "0 auto",
                                      display: "flex",
                                      justifyContent: "center",
                                      pointerEvents: "none",
                                      zIndex: 10,
                                      backgroundColor: "white",
                                    }}
                                  >
                                    <div
                                      style={{
                                        pointerEvents: "auto",
                                        padding: "15px 0",
                                      }}
                                    >
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary px-4 py-2"
                                        onClick={() =>
                                          spLoadMore(
                                            values.productRequests.map(
                                              (p) => p.productId,
                                            ),
                                          )
                                        }
                                        disabled={spLoadingMore}
                                        style={{
                                          borderRadius: "20px",
                                          fontWeight: "400",
                                          fontSize: "14px",
                                          minWidth: "160px",
                                        }}
                                      >
                                        {spLoadingMore ? (
                                          <>
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            Loading...
                                          </>
                                        ) : (
                                          <>
                                            <i className="fas fa-plus-circle me-2" />
                                            Load More
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                );
                              }
                              const isSel = spSelectedProducts.some(
                                (sp) => sp.productId === p.productId,
                              );
                              return (
                                <Checkbox
                                  checked={isSel}
                                  disabled={spLoadingInitial}
                                  onChange={() => {
                                    if (isSel) {
                                      setSpSelectedProducts((prev) =>
                                        prev.filter(
                                          (sp) => sp.productId !== p.productId,
                                        ),
                                      );
                                    } else {
                                      setSpSelectedProducts((prev) => [
                                        ...prev,
                                        {
                                          ...p,
                                          quantity: p.quantity || 1,
                                          rate: p.rate || 0,
                                          amount:
                                            (p.rate || 0) * (p.quantity || 1),
                                        },
                                      ]);
                                    }
                                  }}
                                />
                              );
                            },
                          },
                          {
                            accessorKey: "quantity",
                            header: "Qty",
                            size: 100,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.quantity || 1}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "manufacturerName",
                            header: "Make",
                            size: 140,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.manufacturerName || ""}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "model",
                            header: "Model",
                            size: 130,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.model || ""}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "description",
                            header: "Description",
                            size: 180,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.description || ""}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "sku",
                            header: "SKU",
                            size: 130,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.sku || ""}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "rate",
                            header: "Rate",
                            size: 130,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.rate || 0}
                                </span>
                              ),
                          },
                          {
                            accessorKey: "amount",
                            header: "Amount",
                            size: 110,
                            Cell: ({ row }) =>
                              row.original.isLoadMoreRow ? null : (
                                <span style={{ fontSize: "0.85rem" }}>
                                  {row.original.amount ?? 0}
                                </span>
                              ),
                          },
                          {
                            id: "spAction",
                            header: "Action",
                            size: 70,
                            Cell: ({ row }) => {
                              if (row.original.isLoadMoreRow) return null;
                              return (
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSpViewItem(row.original);
                                    setSpViewModal(true);
                                  }}
                                  title="View"
                                >
                                  <span className="btn-inner">
                                    <IoEyeOutline
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                  </span>
                                </Link>
                              );
                            },
                          },
                        ],
                        [
                          spLoadingMore,
                          values.productRequests,
                          spSelectedProducts,
                          spProducts,
                          spLoadingInitial,
                        ],
                      );

                      const spTableData = useMemo(() => {
                        const currentProductIds = new Set(
                          values.productRequests
                            .map((p) => Number(p.productId))
                            .filter((id) => !isNaN(id)),
                        );
                        const filteredProducts = spProducts.filter(
                          (p) => !currentProductIds.has(Number(p.productId)),
                        );
                        if (
                          !spLoadingInitial &&
                          spNextOffset !== null &&
                          spNextOffset < spTotal
                        ) {
                          return [
                            ...filteredProducts,
                            { id: "SP_LOAD_MORE_FAKE_ID", isLoadMoreRow: true },
                          ];
                        }
                        return filteredProducts;
                      }, [
                        spProducts,
                        spLoadingInitial,
                        spNextOffset,
                        spTotal,
                        values.productRequests,
                      ]);

                      const tableAddProducts = useMaterialReactTable({
                        columns: spTableColumns,
                        data: spTableData,
                        enableColumnFilters: false,
                        enableFullScreenToggle: false,
                        enableFilterMatchHighlighting: false,
                        enableRowDragging: true,
                        enableRowSelection: false,
                        enablePagination: false,
                        enableBottomToolbar: false,
                        muiTableBodyCellProps: ({ cell, row }) => {
                          if (row.original.isLoadMoreRow) {
                            if (cell.column.id === "spSelect") {
                              return {
                                colSpan: 15,
                                sx: {
                                  display: "block",
                                  position: "sticky",
                                  width: "100%",
                                  left: "45%",
                                  bottom: 0,
                                  padding: "0",
                                  borderBottom: "none",
                                  zIndex: 10,
                                  backgroundColor: "white",
                                  height: "70px",
                                  boxShadow: "0px -4px 10px rgba(0,0,0,0.05)",
                                },
                              };
                            }
                            return { sx: { display: "none" } };
                          }
                          return {};
                        },
                        muiTableBodyRowProps: ({ row }) => {
                          const p = row.original;
                          if (p.isLoadMoreRow)
                            return { sx: { cursor: "default" } };
                          return {
                            onClick: (e) => {
                              if (
                                [
                                  "INPUT",
                                  "BUTTON",
                                  "A",
                                  "TEXTAREA",
                                  "SELECT",
                                ].includes(e.target.tagName) ||
                                e.target.closest(".MuiCheckbox-root") ||
                                e.target.closest(".MuiSelect-root") ||
                                e.target.closest(".MuiTableDragHandle-root") ||
                                e.target.closest("svg") ||
                                e.target.closest(".react-select__control")
                              )
                                return;
                              const finalJobId = p.jobId || bulkJobId || null;
                              const newItem = {
                                productId: p.productId,
                                productName: p.productName,
                                rate: p.rate || 0,
                                sku: p.sku || "",
                                quantity: p.quantity || 1,
                                amount: (p.rate || 0) * (p.quantity || 1),
                                model: p.model || "",
                                manufacturerId: p.manufacturerId || null,
                                manufacturerName: p.manufacturerName || "",
                                description: p.description || "",
                                jobId: finalJobId,
                                systemId:
                                  p.systemId ||
                                  (finalJobId && finalJobId == bulkJobId
                                    ? bulkSystemId
                                    : null) ||
                                  null,
                                phaseId:
                                  p.phaseId ||
                                  (finalJobId && finalJobId == bulkJobId
                                    ? bulkPhaseId
                                    : null) ||
                                  null,
                                itemStatus: "add",
                              };
                              const existingItems = (
                                values.productRequests || []
                              ).filter((item) => item.productItemId);
                              const currentNewItems = (
                                values.productRequests || []
                              ).filter((item) => !item.productItemId);
                              setFieldValue("productRequests", [
                                newItem,
                                ...currentNewItems,
                                ...existingItems,
                              ]);
                              setSelectedAddedProducts((prev) => [
                                newItem,
                                ...prev,
                              ]);
                              setHasUnsavedChanges(true);
                            },
                            sx: {
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "rgba(33,108,220,0.05)",
                              },
                            },
                          };
                        },
                        enableGlobalFilter: true,
                        manualFiltering: true,
                        onGlobalFilterChange: setSpSearchText,
                        enableTopToolbar: true,
                        muiTopToolbarProps: {
                          className: "compact-pagination-topbar",
                        },
                        onDraggingRowChange: setDraggingRowProduct,
                        state: {
                          isLoading: spLoadingInitial,
                          globalFilter: spSearchText,
                          draggingRow: draggingRowProduct,
                        },
                        muiRowDragHandleProps: ({ row }) => ({
                          onDragEnd: () => {
                            if (
                              hoveredTableProduct === "product-request-list"
                            ) {
                              const p = row.original;
                              const itemsToMove = spSelectedProducts.some(
                                (item) => item.productId === p.productId,
                              )
                                ? spSelectedProducts
                                : [p];
                              spHandleAdd(
                                setFieldValue,
                                values.productRequests,
                                itemsToMove,
                              );
                            }
                            setHoveredTableProduct(null);
                            setDraggingRowProduct(null);
                          },
                        }),
                        muiTableContainerProps: {
                          sx: { minHeight: "60vh", maxHeight: "60vh" },
                        },
                        muiTablePaperProps: {
                          onDragEnter: () =>
                            setHoveredTableProduct("general-product"),
                          sx: {
                            width: "100%",
                            minWidth: "100%",
                            overflow: "visible",
                          },
                        },
                      });

                      useEffect(() => {
                        if (
                          values?.productRequests &&
                          currentData?.productRequests
                        ) {
                          updateSelectedAddedProducts(
                            values.productRequests,
                            currentData,
                          );
                        }
                      }, [values?.productRequests]);

                      return (
                        <>
                          {/* ── Order Create Modal ── */}
                          <Modal
                            show={showOrderConfirmationModal}
                            onHide={() => {
                              setShowOrderConfirmationModal(false);
                              setAlert({
                                show: false,
                                alertFor: "",
                                message: "",
                                type: "",
                              });
                            }}
                            backdrop="static"
                            keyboard={true}
                            size="xl"
                            centered
                            style={{ zIndex: "9999" }}
                          >
                            <Modal.Header className="custom-modal-header">
                              <Modal.Title>Order Create</Modal.Title>
                              <button
                                type="button"
                                className="btn-close-svg"
                                onClick={() => {
                                  setShowOrderConfirmationModal(false);
                                  setAlert({
                                    show: false,
                                    alertFor: "",
                                    message: "",
                                    type: "",
                                  });
                                }}
                                aria-label="Close"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                              </button>
                            </Modal.Header>
                            <Modal.Body style={{ padding: "1.5rem" }}>
                              <Formik
                                key={
                                  showOrderConfirmationModal
                                    ? selectedData?.id
                                    : "closed"
                                }
                                initialValues={{
                                  poNumber: orderModalData.poNumber || "",
                                  warehouseId:
                                    orderModalData.warehouseId || null,
                                  vendorId: orderModalData.vendorId || null,
                                  shipToAddress:
                                    orderModalData.shipToAddress || "",
                                  items: orderModalData.items || [],
                                }}
                                validationSchema={orderValidationSchema}
                                enableReinitialize={false}
                                onSubmit={async (
                                  values,
                                  { setSubmitting, setTouched },
                                ) => {
                                  setTouched({
                                    poNumber: true,
                                    warehouseId: true,
                                    vendorId: true,
                                    shipToAddress: true,
                                    items: true,
                                  });
                                  await handleCreateOrderFromPR(values);
                                  setSubmitting(false);
                                }}
                              >
                                {({
                                  values: oValues,
                                  errors: oErrors,
                                  touched: oTouched,
                                  handleChange: oHandleChange,
                                  handleBlur: oHandleBlur,
                                  setFieldValue: oSetFieldValue,
                                  setFieldTouched: oSetFieldTouched,
                                  handleSubmit: oHandleSubmit,
                                  submitCount,
                                  isSubmitting: oIsSubmitting,
                                }) => {
                                  useEffect(() => {
                                    if (
                                      JSON.stringify(orderModalData.items) !==
                                      JSON.stringify(oValues.items)
                                    ) {
                                      oSetFieldValue(
                                        "items",
                                        orderModalData.items,
                                      );
                                      oSetFieldValue(
                                        "items",
                                        orderModalData.items,
                                        true,
                                      );
                                    }
                                  }, [orderModalData.items, oSetFieldValue]);
                                  return (
                                    <Form onSubmit={oHandleSubmit}>
                                      <Row>
                                        <Col md={12}>
                                          <div
                                            className="d-flex items-center justify-center alert alert-success alert-dismissible fade show"
                                            role="alert"
                                            style={{ marginBottom: "1rem" }}
                                          >
                                            <strong>Note:</strong> The product
                                            request status will be automatically
                                            set to approved when you create this
                                            order.
                                            <button
                                              type="button"
                                              className="btn-close"
                                              onClick={(e) =>
                                                e.currentTarget
                                                  .closest(".alert")
                                                  .remove()
                                              }
                                              aria-label="Close"
                                            ></button>
                                          </div>
                                        </Col>
                                      </Row>
                                      {alert.show &&
                                        alert.alertFor === "order-modal" && (
                                          <Row>
                                            <Col md={12}>
                                              <div
                                                className="alert alert-danger alert-dismissible fade show"
                                                role="alert"
                                              >
                                                {alert.message}
                                                <button
                                                  type="button"
                                                  className="btn-close"
                                                  onClick={() =>
                                                    setAlert({
                                                      show: false,
                                                      alertFor: "",
                                                      message: "",
                                                      type: "",
                                                    })
                                                  }
                                                  aria-label="Close"
                                                ></button>
                                              </div>
                                            </Col>
                                          </Row>
                                        )}
                                      <Row className="mb-3">
                                        <Col md={6} lg={4}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              PO Number{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="poNumber"
                                              placeholder="Enter PO number"
                                              value={oValues.poNumber}
                                              onChange={oHandleChange}
                                              onBlur={oHandleBlur}
                                              isInvalid={
                                                (oTouched.poNumber ||
                                                  submitCount > 0) &&
                                                !!oErrors.poNumber
                                              }
                                            />
                                            {(oTouched.poNumber ||
                                              submitCount > 0) &&
                                              oErrors.poNumber && (
                                                <div className="text-danger mt-1">
                                                  {oErrors.poNumber}
                                                </div>
                                              )}
                                          </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              Vendor{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              options={vendorOptions}
                                              value={vendorOptions.find(
                                                (o) =>
                                                  o.value === oValues.vendorId,
                                              )}
                                              onChange={(option) =>
                                                oSetFieldValue(
                                                  "vendorId",
                                                  option?.value || null,
                                                )
                                              }
                                              onBlur={() =>
                                                oSetFieldTouched(
                                                  "vendorId",
                                                  true,
                                                )
                                              }
                                              placeholder={
                                                vendorOptions.length === 0 ? (
                                                  <span>No vendor found</span>
                                                ) : (
                                                  "Select Vendor..."
                                                )
                                              }
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              styles={{
                                                option: (b, s) => ({
                                                  ...b,
                                                  backgroundColor: s.isSelected
                                                    ? "#007bff"
                                                    : s.isFocused
                                                      ? "#e6f7ff"
                                                      : "#fff",
                                                  color: "#333",
                                                }),
                                                control: (provided) => ({
                                                  ...provided,
                                                  borderColor:
                                                    (oTouched.vendorId ||
                                                      submitCount > 0) &&
                                                    oErrors.vendorId
                                                      ? "#dc3545"
                                                      : provided.borderColor,
                                                  boxShadow:
                                                    (oTouched.vendorId ||
                                                      submitCount > 0) &&
                                                    oErrors.vendorId
                                                      ? "0 0 0 0.1rem rgba(220, 53, 69, 0.25)"
                                                      : provided.boxShadow,
                                                }),
                                                menuPortal: (b) => ({
                                                  ...b,
                                                  zIndex: 9999,
                                                }),
                                              }}
                                            />
                                            {(oTouched.vendorId ||
                                              submitCount > 0) &&
                                              oErrors.vendorId && (
                                                <div className="text-danger mt-1">
                                                  {oErrors.vendorId}
                                                </div>
                                              )}
                                          </Form.Group>
                                        </Col>
                                        <Col md={6} lg={4}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              Warehouse{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              options={warehouseOptions}
                                              value={warehouseOptions.find(
                                                (o) =>
                                                  o.value ===
                                                  oValues.warehouseId,
                                              )}
                                              onChange={(option) => {
                                                oSetFieldValue(
                                                  "warehouseId",
                                                  option?.value || null,
                                                );
                                                oSetFieldValue(
                                                  "shipToAddress",
                                                  option?.shipTo ||
                                                    oValues.shipToAddress,
                                                );
                                              }}
                                              onBlur={() =>
                                                oSetFieldTouched(
                                                  "warehouseId",
                                                  true,
                                                )
                                              }
                                              placeholder={
                                                warehouseOptions.length ===
                                                0 ? (
                                                  <span>
                                                    No warehouse found
                                                  </span>
                                                ) : (
                                                  "Select Warehouse..."
                                                )
                                              }
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              styles={{
                                                option: (b, s) => ({
                                                  ...b,
                                                  backgroundColor: s.isSelected
                                                    ? "#007bff"
                                                    : s.isFocused
                                                      ? "#e6f7ff"
                                                      : "#fff",
                                                  color: "#333",
                                                }),
                                                control: (provided) => ({
                                                  ...provided,
                                                  borderColor:
                                                    (oTouched.warehouseId ||
                                                      submitCount > 0) &&
                                                    oErrors.warehouseId
                                                      ? "#dc3545"
                                                      : provided.borderColor,
                                                  boxShadow:
                                                    (oTouched.warehouseId ||
                                                      submitCount > 0) &&
                                                    oErrors.warehouseId
                                                      ? "0 0 0 0.1rem rgba(220, 53, 69, 0.25)"
                                                      : provided.boxShadow,
                                                }),
                                                menuPortal: (b) => ({
                                                  ...b,
                                                  zIndex: 9999,
                                                }),
                                              }}
                                            />
                                            {(oTouched.warehouseId ||
                                              submitCount > 0) &&
                                              oErrors.warehouseId && (
                                                <div className="text-danger mt-1">
                                                  {oErrors.warehouseId}
                                                </div>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col md={12}>
                                          <Form.Group className="form-group">
                                            <Form.Label>
                                              Requesting Warehouse Address{" "}
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Form.Control
                                              as="textarea"
                                              rows={3}
                                              name="shipToAddress"
                                              placeholder="Enter ship to address"
                                              value={oValues.shipToAddress}
                                              onChange={oHandleChange}
                                              onBlur={oHandleBlur}
                                              isInvalid={
                                                (oTouched.shipToAddress ||
                                                  submitCount > 0) &&
                                                !!oErrors.shipToAddress
                                              }
                                              style={{
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "8px",
                                              }}
                                            />
                                            {(oTouched.shipToAddress ||
                                              submitCount > 0) &&
                                              oErrors.shipToAddress && (
                                                <div className="text-danger mt-1">
                                                  {oErrors.shipToAddress}
                                                </div>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md={12}>
                                          <div
                                            className="d-flex justify-content-between align-items-center py-3 px-3"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              borderRadius: "8px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              setShowItemsInModal(
                                                !showItemsInModal,
                                              )
                                            }
                                            onMouseEnter={(e) =>
                                              (e.currentTarget.style.backgroundColor =
                                                "#e9ecef")
                                            }
                                            onMouseLeave={(e) =>
                                              (e.currentTarget.style.backgroundColor =
                                                "#f8f9fa")
                                            }
                                          >
                                            <h6
                                              className="mb-0 text-primary"
                                              style={{ fontWeight: "500" }}
                                            >
                                              Products (
                                              {orderModalData.items.length}{" "}
                                              items)
                                            </h6>
                                            <div
                                              className="sidebar-toggle"
                                              style={{ position: "initial" }}
                                            >
                                              <i
                                                className="icon"
                                                style={{
                                                  transform: showItemsInModal
                                                    ? "rotate(90deg)"
                                                    : "rotate(270deg)",
                                                }}
                                              >
                                                <svg
                                                  width="20"
                                                  className="icon-20"
                                                  height="20"
                                                  viewBox="0 0 24 24"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M4.25 12.2744L19.25 12.2744"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  ></path>
                                                  <path
                                                    d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                  ></path>
                                                </svg>
                                              </i>
                                            </div>
                                          </div>
                                          {oTouched.items && oErrors.items && (
                                            <div className="text-danger">
                                              {typeof oErrors.items === "string"
                                                ? oErrors.items
                                                : "At least one item must be selected for order"}
                                            </div>
                                          )}
                                          {showItemsInModal && (
                                            <div
                                              style={{
                                                maxHeight: "calc(75vh - 150px)",
                                                overflowY: "auto",
                                                overflowX: "auto",
                                              }}
                                            >
                                              <Table
                                                className="overflow-auto mt-6"
                                                role="grid"
                                                responsive
                                                style={{
                                                  width: "100%",
                                                  marginTop: "1rem",
                                                }}
                                              >
                                                <thead
                                                  className="sticky-top"
                                                  style={{
                                                    position: "sticky",
                                                    top: 0,
                                                    zIndex: 10,
                                                    backgroundColor: "#e2e4e9",
                                                  }}
                                                >
                                                  <tr
                                                    style={{
                                                      backgroundColor:
                                                        "#e2e4e9",
                                                    }}
                                                  >
                                                    {[
                                                      "Quantity",
                                                      "Make",
                                                      "Model",
                                                      "Description",
                                                      "SKU",
                                                      "Rate",
                                                      "Amount",
                                                      "Job",
                                                      "System",
                                                      "Phase",
                                                      "Site Name",
                                                      "Actions",
                                                    ].map((h) => (
                                                      <th
                                                        key={h}
                                                        style={{
                                                          minWidth: "150px",
                                                        }}
                                                      >
                                                        {h}
                                                      </th>
                                                    ))}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {(() => {
                                                    const filteredItems =
                                                      oValues.items.filter(
                                                        (item) =>
                                                          item.createOrder !==
                                                          false,
                                                      );
                                                    if (
                                                      filteredItems.length === 0
                                                    )
                                                      return (
                                                        <tr>
                                                          <td
                                                            colSpan="13"
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              padding: "2rem",
                                                              fontWeight:
                                                                "bold",
                                                              color: "#6c757d",
                                                            }}
                                                          >
                                                            No products found.
                                                            Add at least one
                                                            product minimum.
                                                          </td>
                                                        </tr>
                                                      );
                                                    return filteredItems.map(
                                                      (item, filteredIndex) => {
                                                        const originalIndex =
                                                          oValues.items.findIndex(
                                                            (i) => i === item,
                                                          );
                                                        const isLastItem =
                                                          filteredItems.length ===
                                                          1;
                                                        return (
                                                          <tr
                                                            key={originalIndex}
                                                          >
                                                            <td>
                                                              {item.quantity}
                                                            </td>
                                                            <td>
                                                              {
                                                                item.manufacturerName
                                                              }
                                                            </td>
                                                            <td>
                                                              {item.model}
                                                            </td>
                                                            <td>
                                                              {item.description || ""}
                                                            </td>
                                                            <td>
                                                              {item.sku ||
                                                                "N/A"}
                                                            </td>
                                                            <td>
                                                              {item.rate || 0}
                                                            </td>
                                                            <td>
                                                              {item.amount || 0}
                                                            </td>
                                                            <td>
                                                              {optionsJob.find(
                                                                (o) =>
                                                                  o.value ===
                                                                  item.jobId,
                                                              )?.label ||
                                                                "No Job Assigned"}
                                                            </td>
                                                            <td>
                                                              {item.jobId &&
                                                              item.systemId &&
                                                              jobSystemsPhasesMap[
                                                                item.jobId
                                                              ]
                                                                ? jobSystemsPhasesMap[
                                                                    item.jobId
                                                                  ].systems.find(
                                                                    (s) =>
                                                                      s.system_id ===
                                                                      item.systemId,
                                                                  )
                                                                    ?.system_name ||
                                                                  "N/A"
                                                                : "N/A"}
                                                            </td>
                                                            <td>
                                                              {item.jobId &&
                                                              item.systemId &&
                                                              item.phaseId &&
                                                              jobSystemsPhasesMap[
                                                                item.jobId
                                                              ]
                                                                ? jobSystemsPhasesMap[
                                                                    item.jobId
                                                                  ].systems
                                                                    .find(
                                                                      (s) =>
                                                                        s.system_id ===
                                                                        item.systemId,
                                                                    )
                                                                    ?.phases.find(
                                                                      (p) =>
                                                                        p.phase_id ===
                                                                        item.phaseId,
                                                                    )
                                                                    ?.phase_name ||
                                                                  "N/A"
                                                                : "N/A"}
                                                            </td>
                                                            <td>
                                                              {optionsJob.find(
                                                                (o) =>
                                                                  o.value ===
                                                                  item.jobId,
                                                              )?.siteName ||
                                                                "N/A"}
                                                            </td>
                                                            <td
                                                              style={{
                                                                textAlign:
                                                                  "center",
                                                              }}
                                                            >
                                                              <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                  <BSTooltip>
                                                                    {isLastItem
                                                                      ? "At least one item is required for order"
                                                                      : "Click to exclude from order"}
                                                                  </BSTooltip>
                                                                }
                                                              >
                                                                <span
                                                                  style={{
                                                                    cursor:
                                                                      isLastItem
                                                                        ? "not-allowed"
                                                                        : "pointer",
                                                                    display:
                                                                      "inline-block",
                                                                  }}
                                                                >
                                                                  <IconButton
                                                                    size="medium"
                                                                    color="error"
                                                                    onClick={() => {
                                                                      if (
                                                                        isLastItem
                                                                      )
                                                                        return;
                                                                      const updatedItems =
                                                                        [
                                                                          ...oValues.items,
                                                                        ];
                                                                      updatedItems[
                                                                        originalIndex
                                                                      ] = {
                                                                        ...updatedItems[
                                                                          originalIndex
                                                                        ],
                                                                        createOrder: false,
                                                                      };
                                                                      oSetFieldValue(
                                                                        "items",
                                                                        updatedItems,
                                                                        true,
                                                                      );
                                                                    }}
                                                                    disabled={
                                                                      isLastItem
                                                                    }
                                                                    style={{
                                                                      cursor:
                                                                        isLastItem
                                                                          ? "not-allowed"
                                                                          : "pointer",
                                                                      opacity:
                                                                        isLastItem
                                                                          ? 0.3
                                                                          : 1,
                                                                    }}
                                                                  >
                                                                    <CancelIcon fontSize="medium" />
                                                                  </IconButton>
                                                                </span>
                                                              </OverlayTrigger>
                                                            </td>
                                                          </tr>
                                                        );
                                                      },
                                                    );
                                                  })()}
                                                </tbody>
                                              </Table>
                                            </div>
                                          )}
                                        </Col>
                                      </Row>
                                      <Modal.Footer className="d-flex justify-content-end">
                                        <Button
                                          variant="primary"
                                          type="submit"
                                          disabled={
                                            isLoading ||
                                            oIsSubmitting ||
                                            oValues.items.filter(
                                              (item) =>
                                                item.createOrder !== false,
                                            ).length === 0
                                          }
                                        >
                                          {isLoading
                                            ? "Creating Order..."
                                            : "Create Order"}
                                        </Button>
                                        <Button
                                          variant="danger"
                                          type="button"
                                          onClick={() => {
                                            setShowOrderConfirmationModal(
                                              false,
                                            );
                                            setAlert({
                                              show: false,
                                              alertFor: "",
                                              message: "",
                                              type: "",
                                            });
                                          }}
                                          disabled={isLoading || oIsSubmitting}
                                        >
                                          Cancel
                                        </Button>
                                      </Modal.Footer>
                                    </Form>
                                  );
                                }}
                              </Formik>
                            </Modal.Body>
                          </Modal>

                          {/* ── Product Add Custom Modal ── */}
                          <Modal
                            show={productAddModel}
                            onHide={handleCloseView}
                            backdrop="true"
                            keyboard={true}
                            className="w-90"
                            size="xl"
                          >
                            <Modal.Header className="custom-modal-header">
                              <Modal.Title>Product Add</Modal.Title>
                              <button
                                type="button"
                                className="btn-close-svg"
                                onClick={handleCloseView}
                                aria-label="Close"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                >
                                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                              </button>
                            </Modal.Header>
                            <Modal.Body>
                              <ProductAddModel
                                handleCloseView={handleCloseView}
                                formData={formDataProduct}
                                setFormData={setFormDataProduct}
                                handleSubmitProductData={
                                  handleSubmitProductData
                                }
                                setFieldValue={setFieldValue}
                                addedProducts={values.productRequests}
                              />
                            </Modal.Body>
                          </Modal>

                          <Form>
                            <FocusError />

                            {/* ── Search + Buttons Row ── */}
                            <Row className="align-items-center mb-4">
                              <Col
                                lg={6}
                                md={12}
                                sm={12}
                                className="mb-2 mb-lg-0"
                              >
                                <Row>
                                  <Col md={6} sm={12} className="mt-3 mt-md-0">
                                    <Form.Group>
                                      <Form.Label className="w-100">
                                        Search
                                        <span
                                          className="d-flex flex-col mt-1"
                                          style={{
                                            width: "100%",
                                            display: "inline-flex",
                                          }}
                                        >
                                          <Form.Control
                                            type="text"
                                            placeholder="Search product"
                                            value={searchSelectedProducts}
                                            onChange={(e) =>
                                              setSearchSelectedProducts(
                                                e.target.value,
                                              )
                                            }
                                            style={{
                                              paddingTop: "7px",
                                              paddingBottom: "7px",
                                            }}
                                          />
                                        </span>
                                      </Form.Label>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                              {hasUpdatePermission && (
                                <Col lg={6} md={12} sm={12}>
                                  <div className="d-flex gap-2 gap-md-4 justify-content-md-end justify-content-start text-nowrap">
                                    <Button
                                      variant="primary"
                                      className="text-nowrap d-flex align-items-center gap-2"
                                      style={{ borderRadius: "0.5rem" }}
                                      onClick={() => {
                                        setActivePanel((prev) =>
                                          prev === "products"
                                            ? "none"
                                            : "products",
                                        );
                                      }}
                                    >
                                      {showAddProductsPanel ? (
                                        <span>Hide New Products</span>
                                      ) : (
                                        <>
                                          <Plus
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          <span>Add New Products</span>
                                        </>
                                      )}
                                    </Button>
                                    {productHasPermission && (
                                      <Button
                                        variant="success"
                                        className="text-nowrap"
                                        onClick={() => {
                                          setProductAddModel(true);
                                          setSelectedJobForFilter(null);
                                          setJobIdProductRequest(null);
                                          setSearchSelectedProducts("");
                                          setSelectedSystemForFilter(null);
                                          setSelectedPhaseForFilter(null);
                                        }}
                                      >
                                        Add Custom Product
                                      </Button>
                                    )}
                                  </div>
                                </Col>
                              )}
                            </Row>

                            {/* ── Split Panel ── */}
                            <div
                              ref={containerRef}
                              style={{
                                display: "flex",
                                flexDirection: isMobile ? "column" : "row",
                                flexWrap: isMobile ? "wrap" : "nowrap",
                                position: "relative",
                                gap: 0,
                              }}
                            >
                              {/* ── LEFT: Product Request Items Table ── */}
                              <div
                                style={{
                                  width: isMobile
                                    ? "100%"
                                    : isRightPanelOpen
                                      ? `calc(${leftWidth}% - 8px)`
                                      : "100%",
                                  transition: isResizing
                                    ? "none"
                                    : "width 0.4s ease-in-out",
                                  flex: isMobile ? "1 1 auto" : "0 0 auto",
                                  minWidth: 0,
                                }}
                              >
                                <Card>
                                  <Card.Header className="d-flex flex-column ps-0">
                                    <div className="header-title w-100 mb-3">
                                      <h5 className="card-title">
                                        Product Request Items
                                      </h5>
                                    </div>
                                    {/* Bulk Job/System/Phase selectors */}
                                    <Row className="mb-3 g-2 mt-2 w-100">
                                      <Col md={4} sm={12}>
                                        <Select
                                          options={optionsJob}
                                          value={
                                            optionsJob.find(
                                              (o) => o.value === bulkJobId,
                                            ) || null
                                          }
                                          onChange={async (opt) => {
                                            const newJobId = opt?.value || null;
                                            setBulkJobId(newJobId);
                                            setBulkSystemId(null);
                                            setBulkPhaseId(null);
                                            setBulkSystemOptions([]);
                                            setBulkPhaseOptions([]);
                                            const applyToItems = (
                                              jid,
                                              sid,
                                              pid,
                                            ) => {
                                              setFieldValue(
                                                "productRequests",
                                                values.productRequests.map(
                                                  (p) => {
                                                    if (p.productItemId)
                                                      return p; 
                                                    const update = { ...p };
                                                    let changed = false;
                                                    if (jid && !p.jobId) {
                                                      update.jobId = jid;
                                                      changed = true;
                                                    }
                                                    if (
                                                      sid &&
                                                      !p.systemId &&
                                                      update.jobId === jid
                                                    ) {
                                                      update.systemId = sid;
                                                      changed = true;
                                                    }
                                                    if (
                                                      pid &&
                                                      !p.phaseId &&
                                                      update.systemId === sid
                                                    ) {
                                                      update.phaseId = pid;
                                                      changed = true;
                                                    }
                                                    return changed ? update : p;
                                                  },
                                                ),
                                              );
                                            };
                                            if (newJobId) {
                                              setLoadingSystemsPhases(true);
                                              try {
                                                let jd =
                                                  jobSystemsPhasesMap[
                                                    newJobId
                                                  ] ||
                                                  (await fetchJobSystemsPhases(
                                                    newJobId,
                                                  ));
                                                if (jd?.systems) {
                                                  const systems =
                                                    jd.systems.map((s) => ({
                                                      value: s.system_id,
                                                      label: s.system_name,
                                                      phases: s.phases,
                                                    }));
                                                  setBulkSystemOptions(systems);
                                                  let finalSid =
                                                    jd.active_system_id || null;
                                                  let finalPid = null;
                                                  if (finalSid) {
                                                    setBulkSystemId(finalSid);
                                                    const activeSys =
                                                      systems.find(
                                                        (s) =>
                                                          s.value === finalSid,
                                                      );
                                                    if (
                                                      activeSys?.phases &&
                                                      jd.active_phase_id
                                                    ) {
                                                      finalPid =
                                                        jd.active_phase_id;
                                                      setBulkPhaseOptions(
                                                        activeSys.phases.map(
                                                          (p) => ({
                                                            value: p.phase_id,
                                                            label: p.phase_name,
                                                          }),
                                                        ),
                                                      );
                                                      setBulkPhaseId(finalPid);
                                                    }
                                                  }
                                                  applyToItems(
                                                    newJobId,
                                                    finalSid,
                                                    finalPid,
                                                  );
                                                } else
                                                  applyToItems(
                                                    newJobId,
                                                    null,
                                                    null,
                                                  );
                                              } finally {
                                                setLoadingSystemsPhases(false);
                                              }
                                            } else
                                              applyToItems(null, null, null);
                                          }}
                                          isClearable
                                          placeholder="Select Job"
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            container: (b) => ({
                                              ...b,
                                              width: "100%",
                                            }),
                                            option: (b, s) => ({
                                              ...b,
                                              backgroundColor: s.isSelected
                                                ? "#007bff"
                                                : s.isFocused
                                                  ? "#e6f7ff"
                                                  : "#fff",
                                              color: "#333",
                                              fontSize: "0.8rem",
                                            }),
                                            menuPortal: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            menu: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                          }}
                                        />
                                      </Col>
                                      <Col md={4} sm={12}>
                                        <Select
                                          options={bulkSystemOptions}
                                          value={
                                            bulkSystemOptions.find(
                                              (o) => o.value === bulkSystemId,
                                            ) || null
                                          }
                                          onChange={(opt) => {
                                            const sid = opt?.value || null;
                                            setBulkSystemId(sid);
                                            setBulkPhaseId(null);
                                            if (!sid) setBulkPhaseOptions([]);
                                            else {
                                              const sys =
                                                bulkSystemOptions.find(
                                                  (s) => s.value === sid,
                                                );
                                              if (sys?.phases)
                                                setBulkPhaseOptions(
                                                  sys.phases.map((p) => ({
                                                    value: p.phase_id,
                                                    label: p.phase_name,
                                                  })),
                                                );
                                            }
                                            setFieldValue(
                                              "productRequests",
                                              values.productRequests.map((p) =>
                                                !p.productItemId &&
                                                p.jobId === bulkJobId &&
                                                !p.systemId
                                                  ? {
                                                      ...p,
                                                      systemId: sid,
                                                      phaseId: null,
                                                    }
                                                  : p,
                                              ),
                                            );
                                          }}
                                          isClearable
                                          isDisabled={!bulkJobId}
                                          placeholder={
                                            !bulkJobId
                                              ? "Select job first"
                                              : "Select System"
                                          }
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            container: (b) => ({
                                              ...b,
                                              width: "100%",
                                            }),
                                            option: (b, s) => ({
                                              ...b,
                                              backgroundColor: s.isSelected
                                                ? "#007bff"
                                                : s.isFocused
                                                  ? "#e6f7ff"
                                                  : "#fff",
                                              color: "#333",
                                              fontSize: "0.8rem",
                                            }),
                                            menuPortal: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            menu: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                          }}
                                        />
                                      </Col>
                                      <Col md={4} sm={12}>
                                        <Select
                                          options={bulkPhaseOptions}
                                          value={
                                            bulkPhaseOptions.find(
                                              (o) => o.value === bulkPhaseId,
                                            ) || null
                                          }
                                          onChange={(opt) => {
                                            const pid = opt?.value || null;
                                            setBulkPhaseId(pid);
                                            setFieldValue(
                                              "productRequests",
                                              values.productRequests.map((p) =>
                                                !p.productItemId &&
                                                p.systemId === bulkSystemId &&
                                                !p.phaseId
                                                  ? { ...p, phaseId: pid }
                                                  : p,
                                              ),
                                            );
                                          }}
                                          isClearable
                                          isDisabled={!bulkSystemId}
                                          placeholder={
                                            !bulkSystemId
                                              ? "Select system first"
                                              : "Select Phase"
                                          }
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            container: (b) => ({
                                              ...b,
                                              width: "100%",
                                            }),
                                            option: (b, s) => ({
                                              ...b,
                                              backgroundColor: s.isSelected
                                                ? "#007bff"
                                                : s.isFocused
                                                  ? "#e6f7ff"
                                                  : "#fff",
                                              color: "#333",
                                              fontSize: "0.8rem",
                                            }),
                                            menuPortal: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            menu: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </Card.Header>
                                  <Card.Body className="ps-0 pe-0">
                                    {typeof errorsFormik?.productRequests ===
                                      "string" &&
                                      values?.productRequests?.length === 0 &&
                                      clickSubmitProduct && (
                                        <span className="text-danger">
                                          {errorsFormik.productRequests}
                                        </span>
                                      )}
                                    <div
                                      className="table-responsive relative"
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        setHoveredTableProduct(
                                          "product-request-list",
                                        );
                                      }}
                                      onDragLeave={() =>
                                        setHoveredTableProduct(null)
                                      }
                                      style={{
                                        outline:
                                          hoveredTableProduct ===
                                          "product-request-list"
                                            ? "2px dashed #216CDC"
                                            : "none",
                                        borderRadius: "8px",
                                        transition: "all 0.2s",
                                      }}
                                    >
                                      <Table
                                        id="order-list-table"
                                        className="table-user overflow-auto"
                                        role="grid"
                                        responsive
                                        data-toggle="data-table"
                                        style={{ width: "100%" }}
                                      >
                                        <thead>
                                          <tr
                                            style={{
                                              backgroundColor: "#e2e4e9",
                                            }}
                                            className="tr-user"
                                          >
                                            <th
                                              className="sticky-head-name th-user"
                                              style={{ minWidth: "100px" }}
                                            >
                                              Quantity
                                            </th>
                                            <th
                                              className="user-select-none th-user"
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "manufacturerName",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="d-flex flex-row align-items-end">
                                                Make{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "manufacturerName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "manufacturerName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              className="user-select-none th-user"
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "model",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="d-flex flex-row align-items-end">
                                                Model{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "model" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "model" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              className="th-user"
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "productName",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="d-flex flex-row align-items-end user-select-none">
                                                Description{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "productName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "productName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "200px" }}
                                            >
                                              SKU
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "200px" }}
                                            >
                                              Rate
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "200px" }}
                                            >
                                              Amount
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "200px" }}
                                            >
                                              Job
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "250px" }}
                                            >
                                              System
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "280px" }}
                                            >
                                              Phase
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "200px" }}
                                            >
                                              Site Name
                                            </th>
                                            <th
                                              className="th-user"
                                              style={{ minWidth: "100px" }}
                                            >
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <FieldArray
                                            name="productRequests"
                                            render={(arrayHelpers) => {
                                              if (
                                                values.productRequests.length <=
                                                itemsPerPage
                                              )
                                                setCurrentPage(1);
                                              const startIndex =
                                                (currentPage - 1) *
                                                itemsPerPage;
                                              const paginatedItems =
                                                getPaginatedItems(
                                                  values.productRequests,
                                                );
                                              const showLoadMore = hasMoreItems(
                                                values.productRequests,
                                              );
                                              const totalWithoutId =
                                                paginatedItems.filter(
                                                  (item) => !item.productItemId,
                                                ).length;
                                              const firstExistingProduct =
                                                paginatedItems?.find(
                                                  (item) => item.productItemId,
                                                );
                                              const firstNewProduct =
                                                paginatedItems?.find(
                                                  (item) => !item.productItemId,
                                                );
                                              return (
                                                <>
                                                  {paginatedItems?.map(
                                                    (item, index) => {
                                                      const absoluteIndex =
                                                        startIndex + index;
                                                      const originalIndex =
                                                        values.productRequests.findIndex(
                                                          (oi, idx) => {
                                                            return (
                                                              Number(
                                                                oi.productId,
                                                              ) ===
                                                                Number(
                                                                  item.productId,
                                                                ) &&
                                                              oi.productItemId ===
                                                                item.productItemId
                                                            );
                                                          },
                                                        );
                                                      const actualIndex =
                                                        originalIndex >= 0
                                                          ? originalIndex
                                                          : absoluteIndex;

                                                      const formikErrors =
                                                        errorsFormik
                                                          ?.productRequests?.[
                                                          actualIndex
                                                        ];
                                                      const touchedFields =
                                                        touched
                                                          ?.productRequests?.[
                                                          actualIndex
                                                        ];
                                                      const generalErrors =
                                                        errors
                                                          ?.productRequests?.[
                                                          actualIndex
                                                        ];
                                                      const hasValidationErrors =
                                                        formikErrors &&
                                                        touchedFields;
                                                      const shouldShowBorder =
                                                        hasValidationErrors ||
                                                        generalErrors;

                                                      const firstNewOverallIdx =
                                                        values.productRequests.findIndex(
                                                          (it) =>
                                                            !it.productItemId,
                                                        );
                                                      const firstExistingOverallIdx =
                                                        values.productRequests.findIndex(
                                                          (it) =>
                                                            it.productItemId,
                                                        );

                                                      const isFirstNewProduct =
                                                        absoluteIndex ===
                                                        firstNewOverallIdx;
                                                      const isFirstExisting =
                                                        absoluteIndex ===
                                                        firstExistingOverallIdx;
                                                      return (
                                                        <React.Fragment
                                                          key={`${item.productId}-${absoluteIndex}`}
                                                        >
                                                          {isFirstNewProduct && (
                                                            <tr>
                                                              
                                                                <div
                                                                  style={{
                                                                    position:
                                                                      "sticky",
                                                                    bottom: 0,
                                                                    left: "40%",
                                                                    width:
                                                                      "100%",
                                                                    display:
                                                                      "flex",
                                                                    justifyContent:
                                                                      "center",
                                                                    background:
                                                                      "none",
                                                                    padding:
                                                                      "1rem 0",
                                                                    zIndex: 10,
                                                                  }}
                                                                >
                                                                  <p
                                                                    className="text-primary border border-primary cursor-pointer btn-lg px-4 py-2 mb-2"
                                                                    style={{
                                                                      borderRadius:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "400",
                                                                      fontSize:
                                                                        "14px",
                                                                      minWidth:
                                                                        "150px",
                                                                    }}
                                                                  >
                                                                    <i className="fas fa-plus-circle me-2"></i>
                                                                    New Products
                                                                  </p>
                                                                </div>
                                                             
                                                            </tr>
                                                          )}
                                                          {isFirstExisting && (
                                                            <tr>
                                                          
                                                                <div
                                                                  style={{
                                                                    position:
                                                                      "sticky",
                                                                    bottom: 0,
                                                                    left: "40%",
                                                                    width:
                                                                      "100%",
                                                                    display:
                                                                      "flex",
                                                                    justifyContent:
                                                                      "center",
                                                                    background:
                                                                      "none",
                                                                    padding:
                                                                      "1rem 0",
                                                                    zIndex: 10,
                                                                  }}
                                                                >
                                                                  <p
                                                                    className="border border-primary text-primary cursor-pointer btn-lg px-4 py-2 mb-2"
                                                                    style={{
                                                                      borderRadius:
                                                                        "20px",
                                                                      fontWeight:
                                                                        "400",
                                                                      fontSize:
                                                                        "14px",
                                                                      minWidth:
                                                                        "150px",
                                                                    }}
                                                                  >
                                                                    <i className="fas fa-plus-circle me-2"></i>
                                                                    Already
                                                                    Added
                                                                    Products
                                                                  </p>
                                                                </div>
                                                             
                                                            </tr>
                                                          )}
                                                          <tr
                                                            key={item.productId}
                                                            className={
                                                              (!item.productItemId &&
                                                                "bg-selected-product relative tr-user") ||
                                                              ((hasValidationErrors ||
                                                                validationErrors?.[
                                                                  item.productId
                                                                ] ||
                                                                inactiveProductErrors.includes(
                                                                  item.productId,
                                                                )) &&
                                                                "error-row relative tr-user") ||
                                                              " relative tr-user"
                                                            }
                                                            style={{
                                                              position:
                                                                "relative",
                                                              ...((shouldShowBorder &&
                                                                !inactiveProductErrors.includes(
                                                                  item.productId,
                                                                )) ||
                                                              validationErrors?.[
                                                                item.productId
                                                              ] ||
                                                              (!shouldShowBorder &&
                                                                inactiveProductErrors.includes(
                                                                  item.productId,
                                                                ))
                                                                ? {
                                                                    border:
                                                                      "2px solid red",
                                                                  }
                                                                : totalWithoutId ===
                                                                    index + 1
                                                                  ? {
                                                                      borderBottom:
                                                                        "2px solid #d1d7dccc",
                                                                      boxShadow:
                                                                        "0px 6px 13px #d1d7dccc",
                                                                    }
                                                                  : {}),
                                                            }}
                                                          >
                                                            {/* Quantity */}
                                                            <td className="sticky-data-names td-user">
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <Form.Control
                                                                  type="text"
                                                                  min={0}
                                                                  max={99999}
                                                                  name={`productRequests.${originalIndex}.quantity`}
                                                                  step="1"
                                                                  value={
                                                                    item.quantity ||
                                                                    ""
                                                                  }
                                                                  disabled={
                                                                    isLoadingQuantity ||
                                                                    !hasUpdatePermission
                                                                  }
                                                                  onChange={async (
                                                                    e,
                                                                  ) => {
                                                                    let value =
                                                                      e.target.value.trim();
                                                                    if (
                                                                      value ===
                                                                      ""
                                                                    ) {
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.quantity`,
                                                                        "",
                                                                      );
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.amount`,
                                                                        "",
                                                                      );
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !/^\d+$/.test(
                                                                        value,
                                                                      )
                                                                    )
                                                                      return;
                                                                    const parsedValue =
                                                                      parseInt(
                                                                        value,
                                                                        10,
                                                                      );
                                                                    if (
                                                                      parsedValue >
                                                                      99999
                                                                    )
                                                                      return;
                                                                    if (
                                                                      !isNaN(
                                                                        parsedValue,
                                                                      ) &&
                                                                      parsedValue >=
                                                                        0
                                                                    ) {
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.quantity`,
                                                                        parsedValue,
                                                                      );
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.amount`,
                                                                        parseFloat(
                                                                          (
                                                                            parsedValue *
                                                                            (item.rate ||
                                                                              0)
                                                                          ).toFixed(
                                                                            2,
                                                                          ),
                                                                        ),
                                                                      );
                                                                    }
                                                                  }}
                                                                  onBlur={async () => {
                                                                    if (
                                                                      item?.productItemId
                                                                    ) {
                                                                      setIsLoadingQuantity(
                                                                        true,
                                                                      );
                                                                      setIsLoadingIndex(
                                                                        originalIndex,
                                                                      );
                                                                      await handleSaveProductItemField(
                                                                        item?.productItemId,
                                                                        "itemStatus",
                                                                        "update",
                                                                        "quantity",
                                                                        item?.quantity,
                                                                        "rate",
                                                                        item.rate,
                                                                        "amount",
                                                                        item?.amount,
                                                                      );
                                                                      setIsLoadingQuantity(
                                                                        false,
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    width:
                                                                      "100px",
                                                                    fontSize:
                                                                      "0.8rem",
                                                                    borderColor:
                                                                      isLoadingIndex ===
                                                                        originalIndex &&
                                                                      successStatus?.field ===
                                                                        "quantity"
                                                                        ? "green"
                                                                        : isLoadingIndex ===
                                                                              originalIndex &&
                                                                            failStatus?.field ===
                                                                              "quantity"
                                                                          ? "red"
                                                                          : "",
                                                                  }}
                                                                />
                                                                {validationErrors?.[
                                                                  item.productId
                                                                ]?.quantity && (
                                                                  <div className="text-danger">
                                                                    {
                                                                      validationErrors[
                                                                        item
                                                                          .productId
                                                                      ].quantity
                                                                    }
                                                                  </div>
                                                                )}
                                                                {isLoadingQuantity &&
                                                                  isLoadingIndex ===
                                                                    originalIndex && (
                                                                    <div
                                                                      style={{
                                                                        position:
                                                                          "absolute",
                                                                        top: "50%",
                                                                        right:
                                                                          "50%",
                                                                        transform:
                                                                          "translateY(-50%)",
                                                                        pointerEvents:
                                                                          "none",
                                                                      }}
                                                                    >
                                                                      <RotatingLines
                                                                        strokeWidth="5"
                                                                        animationDuration="0.75"
                                                                        width="20"
                                                                        strokeColor="#b2b4b9"
                                                                        visible={
                                                                          true
                                                                        }
                                                                      />
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            </td>
                                                            {/* Make */}
                                                            <td className="td-user">
                                                              <Form.Control
                                                                readOnly
                                                                type="text"
                                                                value={
                                                                  item.manufacturerName ||
                                                                  ""
                                                                }
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                  cursor:
                                                                    "not-allowed",
                                                                }}
                                                              />
                                                            </td>
                                                            {/* Model */}
                                                            <td>
                                                              <Form.Control
                                                                readOnly
                                                                type="text"
                                                                value={
                                                                  item.model ||
                                                                  ""
                                                                }
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              />
                                                            </td>
                                                            {/* Product Name */}
                                                            <td className="td-user">
                                                              {item.description ||
                                                                ""}
                                                              {errors
                                                                ?.productRequests?.[
                                                                originalIndex
                                                              ]?.productId && (
                                                                <div className="text-danger">
                                                                  {
                                                                    errors
                                                                      ?.productRequests[
                                                                      originalIndex
                                                                    ]?.productId
                                                                  }
                                                                  <br />
                                                                </div>
                                                              )}
                                                            </td>
                                                            {/* SKU */}
                                                            <td>
                                                              <Form.Control
                                                                readOnly
                                                                type="text"
                                                                value={
                                                                  item.sku || ""
                                                                }
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              />
                                                            </td>
                                                            {/* Rate */}
                                                            <td>
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <Form.Control
                                                                  type="text"
                                                                  step="0.01"
                                                                  min={0}
                                                                  name={`productRequests.${originalIndex}.rate`}
                                                                  value={
                                                                    item.rate ??
                                                                    ""
                                                                  }
                                                                  disabled={
                                                                    isLoadingRate
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) => {
                                                                    const value =
                                                                      e.target
                                                                        .value;
                                                                    if (
                                                                      value ===
                                                                      ""
                                                                    ) {
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.rate`,
                                                                        "",
                                                                      );
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.amount`,
                                                                        "0.00",
                                                                      );
                                                                      return;
                                                                    }
                                                                    if (
                                                                      /^\d*\.?\d{0,2}$/.test(
                                                                        value,
                                                                      )
                                                                    ) {
                                                                      const [
                                                                        integerPart,
                                                                      ] =
                                                                        value.split(
                                                                          ".",
                                                                        );
                                                                      if (
                                                                        integerPart &&
                                                                        integerPart.length >
                                                                          13
                                                                      )
                                                                        return;
                                                                      if (
                                                                        parseFloat(
                                                                          value,
                                                                        ) >
                                                                        9999999999999.99
                                                                      )
                                                                        return;
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.rate`,
                                                                        value,
                                                                      );
                                                                      setFieldValue(
                                                                        `productRequests.${originalIndex}.amount`,
                                                                        parseFloat(
                                                                          value &&
                                                                            item.quantity
                                                                            ? (
                                                                                parseFloat(
                                                                                  value,
                                                                                ) *
                                                                                item.quantity
                                                                              ).toFixed(
                                                                                2,
                                                                              )
                                                                            : "0.00",
                                                                        ),
                                                                      );
                                                                    }
                                                                  }}
                                                                  onBlur={async () => {
                                                                    if (
                                                                      values
                                                                        .productRequests[
                                                                        originalIndex
                                                                      ]
                                                                        ?.productItemId
                                                                    ) {
                                                                      setIsLoadingIndex(
                                                                        originalIndex,
                                                                      );
                                                                      setIsLoadingRate(
                                                                        true,
                                                                      );
                                                                      await handleSaveProductItemField(
                                                                        item?.productItemId,
                                                                        "itemStatus",
                                                                        "update",
                                                                        "rate",
                                                                        item.rate,
                                                                        "quantity",
                                                                        item.quantity,
                                                                        "amount",
                                                                        item?.amount,
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.amount,
                                                                      );
                                                                      setIsLoadingRate(
                                                                        false,
                                                                      );
                                                                    }
                                                                  }}
                                                                  style={{
                                                                    width:
                                                                      "200px",
                                                                    fontSize:
                                                                      "0.8rem",
                                                                    borderColor:
                                                                      isLoadingIndex ===
                                                                        originalIndex &&
                                                                      successStatus?.field ===
                                                                        "rate"
                                                                        ? "green"
                                                                        : isLoadingIndex ===
                                                                              originalIndex &&
                                                                            failStatus?.field ===
                                                                              "rate"
                                                                          ? "red"
                                                                          : "",
                                                                  }}
                                                                />
                                                                {(validationErrors?.[
                                                                  item
                                                                    .productItemId
                                                                ]?.rate ||
                                                                  validationErrors?.[
                                                                    item
                                                                      .productId
                                                                  ]?.rate) && (
                                                                  <div className="text-danger">
                                                                    {validationErrors?.[
                                                                      item
                                                                        .productItemId
                                                                    ]?.rate ||
                                                                      validationErrors?.[
                                                                        item
                                                                          .productId
                                                                      ]?.rate}
                                                                  </div>
                                                                )}
                                                                {isLoadingRate &&
                                                                  isLoadingIndex ===
                                                                    originalIndex && (
                                                                    <div
                                                                      style={{
                                                                        position:
                                                                          "absolute",
                                                                        top: "50%",
                                                                        right:
                                                                          "50%",
                                                                        transform:
                                                                          "translateY(-50%)",
                                                                        pointerEvents:
                                                                          "none",
                                                                      }}
                                                                    >
                                                                      <RotatingLines
                                                                        strokeWidth="5"
                                                                        animationDuration="0.75"
                                                                        width="20"
                                                                        strokeColor="#b2b4b9"
                                                                        visible={
                                                                          true
                                                                        }
                                                                      />
                                                                    </div>
                                                                  )}
                                                              </div>
                                                            </td>
                                                            {/* Amount */}
                                                            <td
                                                              style={{
                                                                width: "200px",
                                                              }}
                                                            >
                                                              <Form.Control
                                                                type="text"
                                                                step="0.01"
                                                                min={0}
                                                                name={`productRequests.${originalIndex}.amount`}
                                                                value={
                                                                  item.amount ||
                                                                  0
                                                                }
                                                                readOnly
                                                                style={{
                                                                  width:
                                                                    "200px",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              />
                                                              {validationErrors?.[
                                                                item.productId
                                                              ]?.amount && (
                                                                <div className="text-danger">
                                                                  {
                                                                    validationErrors[
                                                                      item
                                                                        .productId
                                                                    ].amount
                                                                  }
                                                                </div>
                                                              )}
                                                            </td>
                                                            {/* Job */}
                                                            <td>
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <Select
                                                                  name={`items.${originalIndex}.jobId`}
                                                                  options={
                                                                    optionsJob
                                                                  }
                                                                  value={optionsJob.find(
                                                                    (o) =>
                                                                      o.value ===
                                                                      item.jobId,
                                                                  )}
                                                                  isDisabled={
                                                                    isLoadingJob ||
                                                                    !hasUpdatePermission ||
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.job
                                                                  }
                                                                  onChange={async (
                                                                    selectedOption,
                                                                  ) => {
                                                                    const newJobId =
                                                                      selectedOption?.value ||
                                                                      null;
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.jobId`,
                                                                      newJobId,
                                                                    );
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.systemId`,
                                                                      null,
                                                                    );
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.phaseId`,
                                                                      null,
                                                                    );
                                                                    if (
                                                                      !newJobId
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.productItemId
                                                                      ) {
                                                                        await handleSaveProductItemField(
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            .productItemId,
                                                                          "itemStatus",
                                                                          "update",
                                                                          "jobId",
                                                                          null,
                                                                          "systemId",
                                                                          null,
                                                                          "phaseId",
                                                                          null,
                                                                        );
                                                                      }
                                                                      return;
                                                                    }
                                                                    setLoadingJobSystemPhase(
                                                                      (
                                                                        prev,
                                                                      ) => ({
                                                                        ...prev,
                                                                        [originalIndex]:
                                                                          {
                                                                            ...prev[
                                                                              originalIndex
                                                                            ],
                                                                            job: true,
                                                                          },
                                                                      }),
                                                                    );
                                                                    setIsLoadingIndex(
                                                                      originalIndex,
                                                                    );
                                                                    try {
                                                                      const jobData =
                                                                        await fetchJobSystemsPhases(
                                                                          newJobId,
                                                                        );
                                                                      if (
                                                                        jobData?.active_system_id &&
                                                                        jobData?.active_phase_id
                                                                      ) {
                                                                        setFieldValue(
                                                                          `productRequests.${originalIndex}.systemId`,
                                                                          jobData.active_system_id,
                                                                        );
                                                                        setFieldValue(
                                                                          `productRequests.${originalIndex}.phaseId`,
                                                                          jobData.active_phase_id,
                                                                        );
                                                                        if (
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            ?.productItemId
                                                                        ) {
                                                                          await handleSaveProductItemField(
                                                                            values
                                                                              .productRequests[
                                                                              originalIndex
                                                                            ]
                                                                              ?.productItemId,
                                                                            "itemStatus",
                                                                            "update",
                                                                            "jobId",
                                                                            newJobId,
                                                                            "systemId",
                                                                            jobData.active_system_id,
                                                                            "phaseId",
                                                                            jobData.active_phase_id,
                                                                          );
                                                                        } else {
                                                                          setModifiedProducts(
                                                                            (
                                                                              prev,
                                                                            ) => {
                                                                              const s =
                                                                                new Set(
                                                                                  prev,
                                                                                );
                                                                              s.add(
                                                                                item.productId,
                                                                              );
                                                                              return s;
                                                                            },
                                                                          );
                                                                        }
                                                                      } else {
                                                                        setFocusedField(
                                                                          `system-${originalIndex}-${item.productId}`,
                                                                        );
                                                                      }
                                                                    } catch (error) {
                                                                      setFailStatus(
                                                                        {
                                                                          field:
                                                                            "jobId",
                                                                        },
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setFailStatus(
                                                                            {},
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    } finally {
                                                                      setLoadingJobSystemPhase(
                                                                        (
                                                                          prev,
                                                                        ) => ({
                                                                          ...prev,
                                                                          [originalIndex]:
                                                                            {
                                                                              ...prev[
                                                                                originalIndex
                                                                              ],
                                                                              job: false,
                                                                            },
                                                                        }),
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setIsLoadingIndex(
                                                                            null,
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    }
                                                                  }}
                                                                  placeholder="Select Job"
                                                                  menuPortalTarget={
                                                                    document.body
                                                                  }
                                                                  isClearable
                                                                  menuPosition="fixed"
                                                                  menuPlacement="auto"
                                                                  styles={{
                                                                    container: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      width:
                                                                        "200px",
                                                                    }),
                                                                    control: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      color:
                                                                        "#5e667b",
                                                                      borderColor:
                                                                        isLoadingIndex ===
                                                                          originalIndex &&
                                                                        successStatus?.field ===
                                                                          "jobId"
                                                                          ? "green"
                                                                          : isLoadingIndex ===
                                                                                originalIndex &&
                                                                              failStatus?.field ===
                                                                                "jobId"
                                                                            ? "red"
                                                                            : "",
                                                                    }),
                                                                    option: (
                                                                      b,
                                                                      s,
                                                                    ) => ({
                                                                      ...b,
                                                                      backgroundColor:
                                                                        s.isSelected
                                                                          ? "#007bff"
                                                                          : s.isFocused
                                                                            ? "#e6f7ff"
                                                                            : "#fff",
                                                                      color:
                                                                        "#333",
                                                                      fontSize:
                                                                        "0.8rem",
                                                                    }),
                                                                    menuPortal:
                                                                      (b) => ({
                                                                        ...b,
                                                                        zIndex: 9999,
                                                                      }),
                                                                    placeholder:
                                                                      (b) => ({
                                                                        ...b,
                                                                        whiteSpace:
                                                                          "nowrap",
                                                                        overflow:
                                                                          "hidden",
                                                                        textOverflow:
                                                                          "ellipsis",
                                                                      }),
                                                                  }}
                                                                />
                                                                {validationErrors?.[
                                                                  item.productId
                                                                ]?.jobId && (
                                                                  <div className="text-danger">
                                                                    {
                                                                      validationErrors[
                                                                        item
                                                                          .productId
                                                                      ].jobId
                                                                    }
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </td>
                                                            {/* System */}
                                                            <td>
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <Select
                                                                  name={`productRequests.${originalIndex}.systemId`}
                                                                  options={
                                                                    item.jobId &&
                                                                    jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ]
                                                                      ? jobSystemsPhasesMap[
                                                                          item
                                                                            .jobId
                                                                        ].systems.map(
                                                                          (
                                                                            s,
                                                                          ) => ({
                                                                            value:
                                                                              s.system_id,
                                                                            label:
                                                                              s.system_name,
                                                                          }),
                                                                        )
                                                                      : []
                                                                  }
                                                                  value={
                                                                    item.jobId &&
                                                                    jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ] &&
                                                                    item.systemId
                                                                      ? jobSystemsPhasesMap[
                                                                          item
                                                                            .jobId
                                                                        ].systems
                                                                          .map(
                                                                            (
                                                                              s,
                                                                            ) => ({
                                                                              value:
                                                                                s.system_id,
                                                                              label:
                                                                                s.system_name,
                                                                            }),
                                                                          )
                                                                          .find(
                                                                            (
                                                                              o,
                                                                            ) =>
                                                                              o.value ===
                                                                              item.systemId,
                                                                          )
                                                                      : null
                                                                  }
                                                                  isClearable
                                                                  onChange={async (
                                                                    selectedOption,
                                                                  ) => {
                                                                    const newSystemId =
                                                                      selectedOption?.value ||
                                                                      null;
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.systemId`,
                                                                      newSystemId,
                                                                    );
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.phaseId`,
                                                                      null,
                                                                    );
                                                                    if (
                                                                      focusedField ===
                                                                        `system-${originalIndex}-${item.productId}` &&
                                                                      newSystemId
                                                                    )
                                                                      setFocusedField(
                                                                        null,
                                                                      );
                                                                    if (
                                                                      !newSystemId
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.productItemId
                                                                      ) {
                                                                        await handleSaveProductItemField(
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            .productItemId,
                                                                          "itemStatus",
                                                                          "update",
                                                                          "systemId",
                                                                          null,
                                                                          "phaseId",
                                                                          null,
                                                                          "jobId",
                                                                          item.jobId,
                                                                        );
                                                                      }
                                                                      return;
                                                                    }
                                                                    setLoadingJobSystemPhase(
                                                                      (
                                                                        prev,
                                                                      ) => ({
                                                                        ...prev,
                                                                        [originalIndex]:
                                                                          {
                                                                            ...prev[
                                                                              originalIndex
                                                                            ],
                                                                            system: true,
                                                                          },
                                                                      }),
                                                                    );
                                                                    setIsLoadingIndex(
                                                                      originalIndex,
                                                                    );
                                                                    try {
                                                                      let autoPhaseId =
                                                                        null;
                                                                      if (
                                                                        newSystemId &&
                                                                        item.jobId
                                                                      ) {
                                                                        if (
                                                                          !jobSystemsPhasesMap[
                                                                            item
                                                                              .jobId
                                                                          ]
                                                                        )
                                                                          await fetchJobSystemsPhases(
                                                                            item.jobId,
                                                                          );
                                                                        const jd =
                                                                          jobSystemsPhasesMap[
                                                                            item
                                                                              .jobId
                                                                          ];
                                                                        if (
                                                                          jd &&
                                                                          newSystemId ===
                                                                            jd.active_system_id &&
                                                                          jd.active_phase_id
                                                                        ) {
                                                                          autoPhaseId =
                                                                            jd.active_phase_id;
                                                                          setFieldValue(
                                                                            `productRequests.${originalIndex}.phaseId`,
                                                                            autoPhaseId,
                                                                          );
                                                                        }
                                                                      }
                                                                      if (
                                                                        newSystemId &&
                                                                        item.jobId &&
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.productItemId &&
                                                                        autoPhaseId
                                                                      ) {
                                                                        await handleSaveProductItemField(
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            ?.productItemId,
                                                                          "itemStatus",
                                                                          "update",
                                                                          "systemId",
                                                                          newSystemId,
                                                                          "jobId",
                                                                          item.jobId,
                                                                          "phaseId",
                                                                          autoPhaseId,
                                                                        );
                                                                      } else if (
                                                                        !autoPhaseId
                                                                      ) {
                                                                        setFocusedField(
                                                                          `phase-${originalIndex}-${item.productId}`,
                                                                        );
                                                                        if (
                                                                          !values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            ?.productItemId
                                                                        )
                                                                          setModifiedProducts(
                                                                            (
                                                                              prev,
                                                                            ) => {
                                                                              const s =
                                                                                new Set(
                                                                                  prev,
                                                                                );
                                                                              s.add(
                                                                                item.productId,
                                                                              );
                                                                              return s;
                                                                            },
                                                                          );
                                                                      }
                                                                    } catch (error) {
                                                                      setFailStatus(
                                                                        {
                                                                          field:
                                                                            "systemId",
                                                                        },
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setFailStatus(
                                                                            {},
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    } finally {
                                                                      setLoadingJobSystemPhase(
                                                                        (
                                                                          prev,
                                                                        ) => ({
                                                                          ...prev,
                                                                          [originalIndex]:
                                                                            {
                                                                              ...prev[
                                                                                originalIndex
                                                                              ],
                                                                              system: false,
                                                                            },
                                                                        }),
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setIsLoadingIndex(
                                                                            null,
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    }
                                                                  }}
                                                                  isDisabled={
                                                                    !item.jobId ||
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.system
                                                                  }
                                                                  isLoading={
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.system
                                                                  }
                                                                  placeholder={
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.system
                                                                      ? "Loading..."
                                                                      : !item.jobId
                                                                        ? "First select a job"
                                                                        : "Select System"
                                                                  }
                                                                  menuPortalTarget={
                                                                    document.body
                                                                  }
                                                                  menuPosition="fixed"
                                                                  menuPlacement="auto"
                                                                  styles={{
                                                                    container: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      width:
                                                                        "250px",
                                                                    }),
                                                                    control: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      color:
                                                                        "#5e667b",
                                                                      borderColor:
                                                                        isLoadingIndex ===
                                                                          originalIndex &&
                                                                        successStatus?.field ===
                                                                          "systemId"
                                                                          ? "green"
                                                                          : isLoadingIndex ===
                                                                                originalIndex &&
                                                                              failStatus?.field ===
                                                                                "systemId"
                                                                            ? "red"
                                                                            : focusedField ===
                                                                                `system-${originalIndex}-${item.productId}`
                                                                              ? "#d4ce1dff"
                                                                              : "",
                                                                      boxShadow:
                                                                        focusedField ===
                                                                        `system-${originalIndex}-${item.productId}`
                                                                          ? "0 0 5px #d4ce1dff"
                                                                          : "",
                                                                    }),
                                                                    option: (
                                                                      b,
                                                                      s,
                                                                    ) => ({
                                                                      ...b,
                                                                      backgroundColor:
                                                                        s.isSelected
                                                                          ? "#007bff"
                                                                          : s.isFocused
                                                                            ? "#e6f7ff"
                                                                            : "#fff",
                                                                      color:
                                                                        "#333",
                                                                      fontSize:
                                                                        "0.8rem",
                                                                    }),
                                                                    menuPortal:
                                                                      (b) => ({
                                                                        ...b,
                                                                        zIndex: 9999,
                                                                      }),
                                                                    placeholder:
                                                                      (b) => ({
                                                                        ...b,
                                                                        whiteSpace:
                                                                          "nowrap",
                                                                        overflow:
                                                                          "hidden",
                                                                        textOverflow:
                                                                          "ellipsis",
                                                                      }),
                                                                  }}
                                                                />
                                                                {validationErrors?.[
                                                                  item.productId
                                                                ]?.systemId && (
                                                                  <div className="text-danger">
                                                                    {
                                                                      validationErrors[
                                                                        item
                                                                          .productId
                                                                      ].systemId
                                                                    }
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </td>
                                                            {/* Phase */}
                                                            <td>
                                                              <div
                                                                style={{
                                                                  position:
                                                                    "relative",
                                                                  display:
                                                                    "inline-block",
                                                                  width: "100%",
                                                                }}
                                                              >
                                                                <Select
                                                                  name={`productRequests.${originalIndex}.phaseId`}
                                                                  options={
                                                                    item.jobId &&
                                                                    item.systemId &&
                                                                    jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ]
                                                                      ? jobSystemsPhasesMap[
                                                                          item
                                                                            .jobId
                                                                        ].systems
                                                                          .find(
                                                                            (
                                                                              s,
                                                                            ) =>
                                                                              s.system_id ===
                                                                              item.systemId,
                                                                          )
                                                                          ?.phases.map(
                                                                            (
                                                                              p,
                                                                            ) => ({
                                                                              value:
                                                                                p.phase_id,
                                                                              label:
                                                                                p.phase_name,
                                                                            }),
                                                                          ) ||
                                                                        []
                                                                      : []
                                                                  }
                                                                  value={
                                                                    item.jobId &&
                                                                    item.systemId &&
                                                                    jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ] &&
                                                                    item.phaseId
                                                                      ? jobSystemsPhasesMap[
                                                                          item
                                                                            .jobId
                                                                        ].systems
                                                                          .find(
                                                                            (
                                                                              s,
                                                                            ) =>
                                                                              s.system_id ===
                                                                              item.systemId,
                                                                          )
                                                                          ?.phases.map(
                                                                            (
                                                                              p,
                                                                            ) => ({
                                                                              value:
                                                                                p.phase_id,
                                                                              label:
                                                                                p.phase_name,
                                                                            }),
                                                                          )
                                                                          .find(
                                                                            (
                                                                              o,
                                                                            ) =>
                                                                              o.value ===
                                                                              item.phaseId,
                                                                          )
                                                                      : null
                                                                  }
                                                                  onChange={async (
                                                                    selectedOption,
                                                                  ) => {
                                                                    const newPhaseId =
                                                                      selectedOption?.value ||
                                                                      null;
                                                                    setFieldValue(
                                                                      `productRequests.${originalIndex}.phaseId`,
                                                                      newPhaseId,
                                                                    );
                                                                    if (
                                                                      focusedField ===
                                                                        `phase-${originalIndex}-${item.productId}` &&
                                                                      newPhaseId
                                                                    )
                                                                      setFocusedField(
                                                                        null,
                                                                      );
                                                                    if (
                                                                      !newPhaseId
                                                                    ) {
                                                                      if (
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.productItemId &&
                                                                        item.jobId &&
                                                                        item.systemId
                                                                      ) {
                                                                        await handleSaveProductItemField(
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            .productItemId,
                                                                          "itemStatus",
                                                                          "update",
                                                                          "phaseId",
                                                                          null,
                                                                          "jobId",
                                                                          item.jobId,
                                                                          "systemId",
                                                                          item.systemId,
                                                                        );
                                                                      }
                                                                      return;
                                                                    }
                                                                    if (
                                                                      !item.jobId ||
                                                                      !item.systemId
                                                                    )
                                                                      return;
                                                                    setLoadingJobSystemPhase(
                                                                      (
                                                                        prev,
                                                                      ) => ({
                                                                        ...prev,
                                                                        [originalIndex]:
                                                                          {
                                                                            ...prev[
                                                                              originalIndex
                                                                            ],
                                                                            phase: true,
                                                                          },
                                                                      }),
                                                                    );
                                                                    setIsLoadingIndex(
                                                                      originalIndex,
                                                                    );
                                                                    try {
                                                                      if (
                                                                        values
                                                                          .productRequests[
                                                                          originalIndex
                                                                        ]
                                                                          ?.productItemId
                                                                      ) {
                                                                        await handleSaveProductItemField(
                                                                          values
                                                                            .productRequests[
                                                                            originalIndex
                                                                          ]
                                                                            ?.productItemId,
                                                                          "itemStatus",
                                                                          "update",
                                                                          "phaseId",
                                                                          newPhaseId,
                                                                          "jobId",
                                                                          item.jobId,
                                                                          "systemId",
                                                                          item.systemId,
                                                                        );
                                                                      } else {
                                                                        setModifiedProducts(
                                                                          (
                                                                            prev,
                                                                          ) => {
                                                                            const s =
                                                                              new Set(
                                                                                prev,
                                                                              );
                                                                            s.add(
                                                                              item.productId,
                                                                            );
                                                                            return s;
                                                                          },
                                                                        );
                                                                      }
                                                                    } catch (error) {
                                                                      setFailStatus(
                                                                        {
                                                                          field:
                                                                            "phaseId",
                                                                        },
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setFailStatus(
                                                                            {},
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    } finally {
                                                                      setLoadingJobSystemPhase(
                                                                        (
                                                                          prev,
                                                                        ) => ({
                                                                          ...prev,
                                                                          [originalIndex]:
                                                                            {
                                                                              ...prev[
                                                                                originalIndex
                                                                              ],
                                                                              phase: false,
                                                                            },
                                                                        }),
                                                                      );
                                                                      setTimeout(
                                                                        () =>
                                                                          setIsLoadingIndex(
                                                                            null,
                                                                          ),
                                                                        2000,
                                                                      );
                                                                    }
                                                                  }}
                                                                  isClearable
                                                                  isDisabled={
                                                                    !item.systemId ||
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.phase
                                                                  }
                                                                  isLoading={
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.phase
                                                                  }
                                                                  placeholder={
                                                                    loadingJobSystemPhase[
                                                                      originalIndex
                                                                    ]?.phase
                                                                      ? "Loading..."
                                                                      : !item.systemId
                                                                        ? "First select a system"
                                                                        : "Select Phase"
                                                                  }
                                                                  menuPortalTarget={
                                                                    document.body
                                                                  }
                                                                  menuPosition="fixed"
                                                                  menuPlacement="auto"
                                                                  styles={{
                                                                    container: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      width:
                                                                        "280px",
                                                                    }),
                                                                    control: (
                                                                      b,
                                                                    ) => ({
                                                                      ...b,
                                                                      color:
                                                                        "#5e667b",
                                                                      borderColor:
                                                                        isLoadingIndex ===
                                                                          originalIndex &&
                                                                        successStatus?.field ===
                                                                          "phaseId"
                                                                          ? "green"
                                                                          : isLoadingIndex ===
                                                                                originalIndex &&
                                                                              failStatus?.field ===
                                                                                "phaseId"
                                                                            ? "red"
                                                                            : focusedField ===
                                                                                `phase-${originalIndex}-${item.productId}`
                                                                              ? "#d4ce1dff"
                                                                              : "",
                                                                      boxShadow:
                                                                        focusedField ===
                                                                        `phase-${originalIndex}-${item.productId}`
                                                                          ? "0 0 5px #d4ce1dff"
                                                                          : "",
                                                                    }),
                                                                    option: (
                                                                      b,
                                                                      s,
                                                                    ) => ({
                                                                      ...b,
                                                                      backgroundColor:
                                                                        s.isSelected
                                                                          ? "#007bff"
                                                                          : s.isFocused
                                                                            ? "#e6f7ff"
                                                                            : "#fff",
                                                                      color:
                                                                        "#333",
                                                                      fontSize:
                                                                        "0.8rem",
                                                                    }),
                                                                    menuPortal:
                                                                      (b) => ({
                                                                        ...b,
                                                                        zIndex: 9999,
                                                                      }),
                                                                    placeholder:
                                                                      (b) => ({
                                                                        ...b,
                                                                        whiteSpace:
                                                                          "nowrap",
                                                                        overflow:
                                                                          "hidden",
                                                                        textOverflow:
                                                                          "ellipsis",
                                                                      }),
                                                                  }}
                                                                />
                                                                {validationErrors?.[
                                                                  item.productId
                                                                ]?.phaseId && (
                                                                  <div className="text-danger">
                                                                    {
                                                                      validationErrors[
                                                                        item
                                                                          .productId
                                                                      ].phaseId
                                                                    }
                                                                  </div>
                                                                )}
                                                              </div>
                                                            </td>
                                                            {/* Site Name */}
                                                            <td>
                                                              <Form.Control
                                                                readOnly
                                                                type="text"
                                                                value={
                                                                  optionsJob.find(
                                                                    (o) =>
                                                                      o.value ===
                                                                      values
                                                                        .productRequests[
                                                                        originalIndex
                                                                      ].jobId,
                                                                  )?.siteName ||
                                                                  ""
                                                                }
                                                                style={{
                                                                  resize:
                                                                    "none",
                                                                  width: "auto",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }}
                                                              />
                                                            </td>
                                                            {/* Action */}
                                                            <td
                                                              style={{
                                                                textWrap:
                                                                  "unset",
                                                              }}
                                                            >
                                                              <div className="d-flex justify-content-start align-items-center gap-2">
                                                                <Link
                                                                  style={{
                                                                    height:
                                                                      "fit-content",
                                                                  }}
                                                                  className={`btn btn-sm btn-icon btn-success ${!item.productItemId && "opacity-50"}`}
                                                                  onClick={(
                                                                    e,
                                                                  ) => {
                                                                    e.preventDefault();
                                                                    setShowPopover(
                                                                      null,
                                                                    );
                                                                    togglePopoverItem(
                                                                      null,
                                                                    );
                                                                    handleView(
                                                                      e,
                                                                      values
                                                                        .productRequests[
                                                                        originalIndex
                                                                      ],
                                                                      values?.productRequests
                                                                        ?.map(
                                                                          (
                                                                            it,
                                                                            i,
                                                                          ) =>
                                                                            i !==
                                                                            originalIndex
                                                                              ? it.productId
                                                                              : null,
                                                                        )
                                                                        .filter(
                                                                          (
                                                                            id,
                                                                          ) =>
                                                                            id,
                                                                        ),
                                                                      originalIndex,
                                                                      values,
                                                                      selectedData,
                                                                    );
                                                                  }}
                                                                  title="View"
                                                                >
                                                                  <span className="btn-inner">
                                                                    <IoEyeOutline
                                                                      style={{
                                                                        width:
                                                                          "20px",
                                                                        height:
                                                                          "20px",
                                                                      }}
                                                                    />
                                                                  </span>
                                                                </Link>
                                                                {values
                                                                  .productRequests[
                                                                  originalIndex
                                                                ]
                                                                  ?.productItemId ===
                                                                  null &&
                                                                  loadingStates[
                                                                    originalIndex
                                                                  ] && (
                                                                    <button
                                                                      className="btn btn-warning btn-sm d-flex align-items-start justify-content-center p-1"
                                                                      disabled={
                                                                        true
                                                                      }
                                                                    >
                                                                      <FaSpinner
                                                                        size={
                                                                          16
                                                                        }
                                                                        className="spinner"
                                                                      />
                                                                    </button>
                                                                  )}
                                                                {values
                                                                  .productRequests[
                                                                  originalIndex
                                                                ]
                                                                  .productItemId ? (
                                                                  <OverlayTrigger
                                                                    trigger="click"
                                                                    show={
                                                                      showPopoverItem ===
                                                                      `delete-${originalIndex}`
                                                                    }
                                                                    onToggle={() =>
                                                                      togglePopoverItem(
                                                                        `delete-${originalIndex}`,
                                                                      )
                                                                    }
                                                                    placement="top"
                                                                    overlay={
                                                                      <Popover
                                                                        id={`popover-delete-${originalIndex}`}
                                                                      >
                                                                        <Popover.Header as="h2">
                                                                          <strong>
                                                                            Delete
                                                                          </strong>{" "}
                                                                          <span>{`(${values.productRequests[originalIndex].productName})`}</span>
                                                                          ?
                                                                        </Popover.Header>
                                                                        <Popover.Body>
                                                                          Once
                                                                          deleted,
                                                                          this
                                                                          action
                                                                          cannot
                                                                          be
                                                                          undone.
                                                                          <div className="d-flex justify-content-end mt-2">
                                                                            <Button
                                                                              size="sm"
                                                                              variant="danger"
                                                                              className="me-2"
                                                                              onClick={async (
                                                                                e,
                                                                              ) => {
                                                                                e.preventDefault();
                                                                                if (
                                                                                  deleteIsSubmit
                                                                                ) {
                                                                                  setDeleteIsSubmit(
                                                                                    false,
                                                                                  );
                                                                                  if (
                                                                                    values
                                                                                      .productRequests[
                                                                                      originalIndex
                                                                                    ]
                                                                                      .productItemId
                                                                                  ) {
                                                                                    const result =
                                                                                      await handleDeleteProductItem(
                                                                                        e,
                                                                                        values.id,
                                                                                        values
                                                                                          .productRequests[
                                                                                          originalIndex
                                                                                        ]
                                                                                          .productItemId,
                                                                                      );
                                                                                    if (
                                                                                      result
                                                                                    ) {
                                                                                      setFieldValue(
                                                                                        "productRequests",
                                                                                        values.productRequests.filter(
                                                                                          (
                                                                                            _,
                                                                                            i,
                                                                                          ) =>
                                                                                            i !==
                                                                                            originalIndex,
                                                                                        ),
                                                                                      );
                                                                                    }
                                                                                  } else {
                                                                                    setFieldValue(
                                                                                      "productRequests",
                                                                                      values.productRequests.filter(
                                                                                        (
                                                                                          _,
                                                                                          i,
                                                                                        ) =>
                                                                                          i !==
                                                                                          originalIndex,
                                                                                      ),
                                                                                    );
                                                                                  }
                                                                                  setDeleteIsSubmit(
                                                                                    true,
                                                                                  );
                                                                                  togglePopoverItem(
                                                                                    `delete-${originalIndex}`,
                                                                                  );
                                                                                }
                                                                              }}
                                                                            >
                                                                              Delete
                                                                            </Button>
                                                                            <Button
                                                                              size="sm"
                                                                              className="text-black bg-white"
                                                                              variant="secondary"
                                                                              onClick={() =>
                                                                                togglePopoverItem(
                                                                                  `delete-${originalIndex}`,
                                                                                )
                                                                              }
                                                                            >
                                                                              Cancel
                                                                            </Button>
                                                                          </div>
                                                                        </Popover.Body>
                                                                      </Popover>
                                                                    }
                                                                  >
                                                                    <Link
                                                                      className={`btn btn-sm btn-icon btn-danger ${!item.productItemId && "opacity-50"}`}
                                                                      title="Delete"
                                                                      onClick={() =>
                                                                        togglePopoverItem(
                                                                          `delete-${originalIndex}`,
                                                                        )
                                                                      }
                                                                    >
                                                                      <span className="btn-inner">
                                                                        <svg
                                                                          width="20"
                                                                          viewBox="0 0 24 24"
                                                                          fill="none"
                                                                          xmlns="http://www.w3.org/2000/svg"
                                                                          stroke="currentColor"
                                                                        >
                                                                          <path
                                                                            d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                          ></path>
                                                                          <path
                                                                            d="M20.708 6.23975H3.75"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                          ></path>
                                                                          <path
                                                                            d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973"
                                                                            stroke="currentColor"
                                                                            strokeWidth="1.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                          ></path>
                                                                        </svg>
                                                                      </span>
                                                                    </Link>
                                                                  </OverlayTrigger>
                                                                ) : (
                                                                  <Link
                                                                    style={{
                                                                      height:
                                                                        "fit-content",
                                                                    }}
                                                                  >
                                                                    <Tooltip title="Remove">
                                                                      <IconButton
                                                                        size="medium"
                                                                        color="error"
                                                                        onClick={() => {
                                                                          const updatedItems =
                                                                            values.productRequests.filter(
                                                                              (
                                                                                _,
                                                                                i,
                                                                              ) =>
                                                                                i !==
                                                                                originalIndex,
                                                                            );
                                                                          setFieldValue(
                                                                            "productRequests",
                                                                            updatedItems,
                                                                          );
                                                                          updateSelectedAddedProducts(
                                                                            updatedItems,
                                                                            currentData,
                                                                          );
                                                                        }}
                                                                      >
                                                                        <CancelIcon fontSize="medium" />
                                                                      </IconButton>
                                                                    </Tooltip>
                                                                  </Link>
                                                                )}
                                                              </div>
                                                            </td>
                                                          </tr>
                                                        </React.Fragment>
                                                      );
                                                    },
                                                  )}
                                                  <tr>
                                                    {paginatedItems.length >
                                                      0 &&
                                                      showLoadMore && (
                                                        <div
                                                          style={{
                                                            position: "sticky",
                                                            bottom: 0,
                                                            left: "40%",
                                                            width: "100%",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            padding: "1rem 0",
                                                            zIndex: 10,
                                                          }}
                                                        >
                                                          <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-lg px-4 py-2 mb-2"
                                                            onClick={
                                                              loadMoreItems
                                                            }
                                                            disabled={
                                                              isLoadingMoreSelectedProduct
                                                            }
                                                            style={{
                                                              borderRadius:
                                                                "20px",
                                                              fontWeight: "400",
                                                              fontSize: "14px",
                                                              minWidth: "150px",
                                                            }}
                                                          >
                                                            {isLoadingMoreSelectedProduct ? (
                                                              <>
                                                                <span
                                                                  className="spinner-border spinner-border-sm me-2"
                                                                  role="status"
                                                                  aria-hidden="true"
                                                                ></span>
                                                                Loading...
                                                              </>
                                                            ) : (
                                                              <>
                                                                <i className="fas fa-plus-circle me-2"></i>
                                                                Load More
                                                              </>
                                                            )}
                                                          </button>
                                                        </div>
                                                      )}
                                                    {(values.productRequests
                                                      .length === 0 ||
                                                      paginatedItems.length ===
                                                        0 ||
                                                      (values.productRequests
                                                        .length > 0 &&
                                                        searchSelectedProducts.trim()
                                                          .length > 0)) && (
                                                      <div
                                                        style={{
                                                          position: "sticky",
                                                          bottom: 0,
                                                          left: "30%",
                                                          width: "100%",
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          padding: "3rem 0",
                                                          zIndex: 10,
                                                        }}
                                                      >
                                                        <div className="align-items-center text-muted">
                                                          <i className="fas fa-search fa-3x mb-3 opacity-50"></i>
                                                          {values
                                                            .productRequests
                                                            .length === 0 ? (
                                                            <>
                                                              No products have
                                                              been added yet.{" "}
                                                              <a
                                                                style={{
                                                                  color:
                                                                    "#007bff",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  setActivePanel(
                                                                    "products",
                                                                  )
                                                                }
                                                              >
                                                                {hasUpdatePermission &&
                                                                  "Add some products"}
                                                              </a>
                                                              {hasUpdatePermission &&
                                                                " to continue."}
                                                            </>
                                                          ) : (
                                                            paginatedItems.length ===
                                                              0 && (
                                                              <p className="mb-0">
                                                                No products
                                                                found. Try
                                                                adjusting your
                                                                search criteria.
                                                              </p>
                                                            )
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </tr>
                                                </>
                                              );
                                            }}
                                          />
                                        </tbody>
                                      </Table>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </div>

                              {/* ── Resize Handle ── */}
                              {!isMobile && isRightPanelOpen && (
                                <Tooltip
                                  title="Drag to resize panels"
                                  placement="top"
                                  arrow
                                >
                                  <div
                                    onMouseDown={startResizing}
                                    style={{
                                      width: "16px",
                                      cursor: "col-resize",
                                      zIndex: 10,
                                      flex: "0 0 auto",
                                      position: "relative",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: isResizing
                                        ? "rgba(0,123,255,0.05)"
                                        : "transparent",
                                      transition: "background 0.3s",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "1px",
                                        height: "78%",
                                        borderLeft: isResizing
                                          ? "2px solid #007bff"
                                          : "2px dotted #adb5bd",
                                        opacity: isResizing ? 1 : 0.6,
                                        transition: "all 0.3s",
                                        position: "absolute",
                                      }}
                                    />
                                    <div
                                      style={{
                                        width: "16px",
                                        height: "40px",
                                        borderRadius: "4px",
                                        background: isResizing
                                          ? "#007bff"
                                          : "#fff",
                                        border: isResizing
                                          ? "1px solid #007bff"
                                          : "1px solid #adb5bd",
                                        zIndex: 11,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s",
                                      }}
                                    >
                                      {[0, 1, 2].map((i) => (
                                        <div
                                          key={i}
                                          style={{
                                            width: "2px",
                                            height: "2px",
                                            borderRadius: "50%",
                                            background: isResizing
                                              ? "#fff"
                                              : "#adb5bd",
                                          }}
                                        />
                                      ))}
                                    </div>
                                  </div>
                                </Tooltip>
                              )}

                              {/* ── RIGHT: General Products Panel ── */}
                              <div
                                style={{
                                  width: isMobile
                                    ? isRightPanelOpen
                                      ? "100%"
                                      : "0%"
                                    : isRightPanelOpen
                                      ? `calc(${100 - leftWidth}% - 8px)`
                                      : "0%",
                                  height: isRightPanelOpen ? "auto" : "0px",
                                  opacity: isRightPanelOpen ? 1 : 0,
                                  transition: isResizing
                                    ? "none"
                                    : "width 0.4s ease-in-out, opacity 0.3s ease-in-out",
                                  overflow: "hidden",
                                  visibility: isRightPanelOpen
                                    ? "visible"
                                    : "hidden",
                                  maxWidth: isMobile
                                    ? "100%"
                                    : isRightPanelOpen
                                      ? `calc(${100 - leftWidth}% - 8px)`
                                      : "0%",
                                  flex: isMobile ? "1 1 auto" : "0 0 auto",
                                }}
                              >
                                {showAddProductsPanel && (
                                  <div
                                    style={{
                                      opacity: 1,
                                      transform: "translateX(0)",
                                      transition:
                                        "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                                    }}
                                  >
                                    {/* Header */}
                                    <Card.Header className="d-flex justify-content-between align-items-start ps-0 pt-2 pb-3 flex-wrap gap-2">
                                      <div className="header-title">
                                        <h5 className="card-title">
                                          General Products
                                        </h5>
                                        <p className="card-title">
                                          Drag or click a product to add it to
                                          the request
                                        </p>
                                      </div>
                                      <Col
                                        md={5}
                                        className="d-flex flex-row justify-content-end align-items-center mb-0"
                                      >
                                        <Form.Label
                                          className="text-nowrap me-2 mt-1"
                                          style={{ fontSize: "16px" }}
                                        >
                                          Filter by{" "}
                                        </Form.Label>
                                        <Select
                                          options={optionsVendor}
                                          value={optionsVendor.find(
                                            (o) =>
                                              o.value === spSelectedVendorId,
                                          )}
                                          onChange={(option) => {
                                            setSpSelectedVendorId(
                                              option?.value || "all",
                                            );
                                          }}
                                          isClearable
                                          placeholder="Select Vendor"
                                          styles={{
                                            container: (b) => ({
                                              ...b,
                                              width: "100%",
                                            }),
                                            option: (b, s) => ({
                                              ...b,
                                              backgroundColor: s.isSelected
                                                ? "#007bff"
                                                : s.isFocused
                                                  ? "#e6f7ff"
                                                  : "#fff",
                                              color: "#333",
                                              fontSize: "0.8rem",
                                            }),
                                            menuPortal: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            menu: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                          }}
                                        />
                                      </Col>
                                    </Card.Header>

                                    <Card.Body className="ps-0 pe-0 pt-0">
                                      <Box
                                        sx={{
                                          width: "100%",
                                          overflow: "visible",
                                          "& .MuiToolbar-root": {
                                            minHeight: "auto !important",
                                            py: "8px",
                                          },
                                          marginTop: "5.5rem",
                                        }}
                                      >
                                        <MaterialReactTable
                                          table={tableAddProducts}
                                        />
                                      </Box>
                                      {/* Add Selected button */}
                                      {spSelectedProducts.length > 0 && (
                                        <div className="d-flex justify-content-end mt-3">
                                          <Button
                                            variant="primary"
                                            onClick={() =>
                                              spHandleAdd(
                                                setFieldValue,
                                                values.productRequests,
                                              )
                                            }
                                            style={{
                                              borderRadius: "0.5rem",
                                              minWidth: "160px",
                                            }}
                                          >
                                            Add {spSelectedProducts.length}{" "}
                                            Selected Product
                                            {spSelectedProducts.length > 1
                                              ? "s"
                                              : ""}
                                          </Button>
                                        </div>
                                      )}
                                    </Card.Body>
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* ── Submit Button ── */}
                            <div className="d-flex justify-content-end mt-4">
                              <Button
                                type="button"
                                variant="primary"
                                className="me-4"
                                disabled={
                                  !isSubmitItem ||
                                  !values.productRequests?.some(
                                    (item) => item.itemStatus === "add",
                                  )
                                }
                                onClick={async (e) => {
                                  const hasAddItem =
                                    values.productRequests?.some(
                                      (item) => item.itemStatus === "add",
                                    );
                                  if (hasAddItem && isSubmitItem) {
                                    setIsSubmitItem(false);
                                    await handleClickItems(
                                      e,
                                      values.productRequests,
                                    );
                                  }
                                }}
                              >
                                Submit
                              </Button>
                              <Button
                                variant="danger"
                                className="me-4"
                                onClick={() =>
                                  navigate(
                                    "/dashboard/app/product-request-list",
                                  )
                                }
                              >
                                Cancel
                              </Button>
                            </div>
                          </Form>
                        </>
                      );
                    }}
                  </Formik>
                )}
                {loader && <FadeLoaderComponent />}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProductRequestEdit;
